/*
 * Mobau Pro – Shop-Suche (Agent C, 10/2026)
 * 1) Sofortsuche beim Tippen: Produkte mit Bild/Preis/Verfügbarkeit, passende Kategorien, Suchvorschläge.
 * 2) Ergebnisseite (/search): Filter (Kategorie, Marke, Preis, Verfügbarkeit), Sortierung, Seiten.
 * Daten: Suchdienst (Meilisearch, nur öffentliche Produktdaten, Nur-Such-Schlüssel). Antwortet er nicht,
 * bleibt die normale Shopify-Suche stehen — die Seite funktioniert also auch ohne ihn.
 */
(function () {
  'use strict';
  // FastClick (timber.js, FastClick.attach(document.body)) fängt auf iOS touchend an Eingabefeldern ab, ruft
  // preventDefault und fokussiert per Skript — iOS öffnet dabei keine Tastatur, der Kunde muss doppelt tippen
  // (11.10., Dennis: „doppelt auf die Suchleiste tippen“). „needsclick“ hilft bei Feldern nicht (FastClick prüft
  // Felder vorher). Deshalb erreichen Touch-Ereignisse auf Eingabefeldern FastClick gar nicht erst: Abfangen in der
  // Capture-Phase am window, nur für Text-/Zahl-/Suchfelder, Textbereiche und Auswahllisten — alles andere bleibt.
  if (!window.__mobauOhneFastClick) {
    window.__mobauOhneFastClick = true;
    var KEIN_TEXT = { button: 1, checkbox: 1, radio: 1, submit: 1, image: 1, file: 1, reset: 1, hidden: 1, range: 1, color: 1 };
    ['touchstart', 'touchend'].forEach(function (typ) {
      window.addEventListener(typ, function (e) {
        var t = e.target;
        if (!t || !t.tagName) return;
        var tag = t.tagName.toLowerCase();
        if ((tag === 'input' && !KEIN_TEXT[(t.type || 'text').toLowerCase()]) || tag === 'textarea' || tag === 'select') e.stopPropagation();
      }, true);
    });
  }
  var CFG = window.MOBAU_SUCHE || {};
  if (!CFG.url || !CFG.key || !window.fetch || window.__mobauSuche) return;
  window.__mobauSuche = true;
  /* I: Suchprotokoll-Hooks */ function melde(art, d) { try { d.art = art; document.dispatchEvent(new CustomEvent('mobau:suche', { detail: d })); } catch (e) {} }

  // Das Theme (theme.js.liquid, Kollektions- und Produktseiten) lädt bei JEDEM „change“ eines <input> die Seite neu,
  // wenn [name=id] nicht die Ausgangsvariante ist — Enter im Suchfeld löst „change“ aus, der Reload bricht die Suche ab.
  // Deshalb erreicht „change“ aus dem Suchfeld keine fremden Handler (Abfangen in der Capture-Phase am window).
  function istSuchfeld(el) {
    return !!(el && el.name === 'q' && el.form && /\/search(\?|$)/.test(el.form.getAttribute('action') || ''));
  }
  window.addEventListener('change', function (e) { if (istSuchfeld(e.target)) e.stopPropagation(); }, true);

  // Bild-Sicherheitsnetz: Der Index trägt die Bild-URL vom Indexlauf. Legt der Shop Medien neu an, wird sie 404.
  // Dann holen wir das aktuelle Titelbild über /products/<handle>.js; gibt es keins, erscheint der Platzhalter.
  var PLATZHALTER = '<span class="mb-card__noimg"><svg aria-hidden="true" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="2"/><path d="m21 17-5-5-9 8"/></svg><small>Kein Bild vorhanden</small></span>';
  var bildCache = {};
  function bildErsetzen(img) {
    var handle = img.getAttribute('data-ms-handle'), breite = img.getAttribute('data-ms-breite') || '360';
    function platzhalter() {
      if (img.closest('.ms-prod__bild')) { img.outerHTML = '<span class="ms-noimg" aria-hidden="true"></span>'; return; }
      var span = document.createElement('span'); span.innerHTML = PLATZHALTER; img.replaceWith(span.firstChild);
    }
    if (!handle || img.getAttribute('data-ms-ersetzt')) { platzhalter(); return; }
    img.setAttribute('data-ms-ersetzt', '1');
    bildCache[handle] = bildCache[handle] || fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) { var u = p.featured_image || (p.images || [])[0]; return u ? (u.indexOf('//') === 0 ? 'https:' + u : u) : null; })
      .catch(function () { return null; });
    bildCache[handle].then(function (u) {
      if (!u) { platzhalter(); return; }
      img.removeAttribute('srcset');
      img.src = bildUrl(u, breite);
    });
  }
  window.addEventListener('error', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.hasAttribute('data-ms-handle')) bildErsetzen(t);
  }, true);

  // Index-Namen kommen aus snippets/search-bar.liquid (je Shop eigener Index: Test „produkte“, Live „produkte_live“).
  var INDEX = CFG.index || 'produkte';
  var KAT_INDEX = CFG.kategorien || 'kategorien';
  var FELDER = ['id', 'handle', 'titel', 'bild', 'preis', 'preis_max', 'vergleichspreis', 'grundpreis', 'verfuegbar',
    'marke', 'kategorie', 'kategorie_id', 'produktart_haupt', 'varianten', 'variante_id', 'nummern', 'nummer_variante', 'energie', 'abholung', 'strecke', 'angebot', 'zuschnitt', 'preiseinheit', 'preiseinheit_text', 'bestand', 'bestand_einheit', 'bestand_einheit1', 'biozid', 'zl', 'zl_uebach']; /* A: Preiseinheit, Bestand; PSM/Biozid 12.10.: biozid */
  // Dropdown: nur, was die Zeile zeigt (kleine Antwort = schneller).
  var DROP_FELDER = ['handle', 'titel', 'bild', 'preis', 'preis_max', 'grundpreis', 'verfuegbar', 'strecke', 'energie', 'kategorie_id',
    'produktart_haupt', 'marke', 'varianten', 'nummern', 'nummer_variante', 'zuschnitt', 'preiseinheit', 'zl', 'zl_uebach']; /* A: Preiseinheit; Zentrallager 13.10. */
  // Beliebte Suchen (häufigste erste Kundenanfragen im Mobau-Chat, Stand 10.10.) — für das leere Suchfeld.
  var BELIEBT = ['Wandfarbe', 'Fliesenkleber', 'Laminat', 'Silikon', 'Estrich', 'Schlauchverbinder', 'WC-Sitz', 'Kantholz', 'Leuchtmittel', 'Wetterschutzfarbe'];
  var SORT = {
    relevanz: null,
    preis_auf: ['preis:asc'],
    preis_ab: ['preis:desc'],
    beliebt: ['verfuegbar:desc', 'beliebt:desc'],
    name: ['titel:asc']
  };
  var SORT_NAMEN = { relevanz: 'Relevanz', beliebt: 'Beliebtheit', preis_auf: 'Preis aufsteigend', preis_ab: 'Preis absteigend', name: 'Name A–Z' };
  var PRO_SEITE = 48; // D 10.10.: 48 je Seite + „Weitere Artikel laden“

  // ---------------------------------------------------------------- Hilfen
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function euro(n) {
    return Number(n).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function bildUrl(url, breite) {
    if (!url) return '';
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + breite;
  }
  function anfrage(queries, signal) {
    return fetch(CFG.url.replace(/\/$/, '') + '/multi-search', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + CFG.key },
      body: JSON.stringify({ queries: queries }),
      signal: signal
    }).then(function (r) {
      if (!r.ok) throw new Error('Suchdienst ' + r.status);
      return r.json();
    }).then(function (d) { return d.results; });
  }
  // Kategorie-Link: die Sortiments-Kollektion, solange sie Produkte hat — sonst die Suche, gefiltert auf diese Kategorie.
  function katUrl(e, q) {
    return e.produkte > 0 ? '/collections/' + encodeURIComponent(e.handle) : suchUrl(q) + '&kat=' + encodeURIComponent(e.id);
  }
  // Produkt-Link; bei Suche nach Artikelnummer/EAN direkt die passende Ausführung.
  function produktUrl(h, q) {
    var n = String(q || '').replace(/\s/g, '').toLowerCase();
    // auch ein einzelnes Wort mit Ziffern („ottoseal c1282“ → Farbcode c1282)
    var toks = String(q || '').toLowerCase().split(/[\s,;]+/).map(function (t) { return t.replace(/^[.:()]+|[.:()]+$/g, ''); })
      .filter(function (t) { return t.length >= 3 && /\d/.test(t); });
    var v = null;
    (h.nummer_variante || []).forEach(function (e) {
      var i = String(e).lastIndexOf(':'), k = String(e).slice(0, i).toLowerCase();
      if (k === n || (!v && toks.indexOf(k) >= 0)) v = String(e).slice(i + 1);
    });
    return '/products/' + encodeURIComponent(h.handle) + (v && h.varianten > 1 ? '?variant=' + v : '');
  }
  function istNummer(q) { return /^\d{4,14}$/.test(q.replace(/\s/g, '')); }
  /* Artikelnummer/EAN, die nicht im Suchindex steht (z. B. Hersteller-Zubehör im Streckengeschäft, nicht frei stöberbar):
     Shopify-Suche NUR über SKU und Barcode — genau ein Treffer → Produkt-URL, sonst null. */
  function nummerImShop(q) {
    var n = String(q || '').replace(/\s/g, '');
    if (!istNummer(n) || !window.fetch) return Promise.resolve(null);
    var u = '/search/suggest.json?q=' + encodeURIComponent(n) + '&resources[type]=product&resources[limit]=2' +
      '&resources[options][fields]=variants.sku,variants.barcode&resources[options][unavailable_products]=last';
    return fetch(u, { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      var p = (((d || {}).resources || {}).results || {}).products || [];
      return p.length === 1 ? p[0].url : null;
    }).catch(function () { return null; });
  }
  function suchUrl(q) { return '/search?type=product&q=' + encodeURIComponent(q); }

  // Kategorien (Sortimentsbereiche) einmal laden: id → {name, handle, bereich}
  var kategorienPromise = null;
  function kategorien() {
    if (kategorienPromise) return kategorienPromise;
    var cache = null;
    try { cache = JSON.parse(sessionStorage.getItem('mobauKat4-' + KAT_INDEX) || 'null'); } catch (e) { cache = null; }
    if (cache) { kategorienPromise = Promise.resolve(cache); return kategorienPromise; }
    kategorienPromise = anfrage([{ indexUid: KAT_INDEX, q: '', limit: 300 }]).then(function (res) {
      var map = {};
      (res[0].hits || []).forEach(function (k) { map[k.id] = k; });
      try { sessionStorage.setItem('mobauKat4-' + KAT_INDEX, JSON.stringify(map)); } catch (e) { /* privat */ }
      return map;
    }).catch(function () { kategorienPromise = null; return {}; });
    return kategorienPromise;
  }


  // ---------------------------------------------------------------- Anfrage verstehen (Agent C, 10.10.)
  // Meilisearch lässt bei zu vielen Wörtern von HINTEN weg; im Deutschen steht das Wichtige (der Kopf) aber hinten
  // („hellblaue wandfarbe“, „fliesen für das bad“). Deshalb stellen wir um: Kern · Maße · Zusatz nach „für/mit …“ ·
  // Farben/Beiwörter/Räume · Projektmengen. Findet auch das nichts, probieren wir kürzere Fassungen (anfrageVarianten).
  // Spiegel zum Messen: SCR/agent-c/varianten.py — beide gleich halten.
  var WEICH = /^(?:(?:hell|dunkel)?(?:weiß|weiss|grau|schwarz|rot|rosa|pink|blau|grün|gruen|gelb|braun|beige|orange|lila|violett|türkis|creme|anthrazit|silber|gold|bunt)(?:e|er|es|en|em)?|hell(?:e|er|es|en)?|dunkel|dunkle(?:r|s|n)?|matt(?:e|er|es|en)?|glänzend(?:e|er|es|en)?|seidenmatt(?:e|er|es|en)?|günstig(?:e|er|es|en)?|billig(?:e|er|es|en)?|gut(?:e|er|es|en)?|groß(?:e|er|es|en)?|gross(?:e|er|es|en)?|klein(?:e|er|es|en)?|neu(?:e|er|es|en)?|möglichst|bitte|mal|kaufen|bestellen|(?:schlaf|wohn|kinder|arbeits|ess|bade)zimmer|wohnung|haus|innen|außen|aussen|draußen|drinnen|innenbereich|außenbereich|verlegen|streichen|bauen|errichten|setzen|hochziehen|anbringen|befestigen|montieren|sanieren|renovieren|dämmen|passend(?:e|er|es|en)?)$/;
  var SCHNITT = { 'für': 1, 'fürs': 1, 'fuer': 1, 'fuers': 1, 'zum': 1, 'zur': 1, 'mit': 1, 'als': 1, 'in': 1, 'im': 1, 'auf': 1, 'an': 1, 'am': 1, 'ohne': 1, 'von': 1, 'vom': 1, 'aus': 1 };
  var STOPP = { 'der': 1, 'die': 1, 'das': 1, 'den': 1, 'dem': 1, 'des': 1, 'ein': 1, 'eine': 1, 'einen': 1, 'einem': 1, 'einer': 1, 'und': 1, 'oder': 1, 'ich': 1, 'brauche': 1, 'suche': 1, 'möchte': 1, 'meine': 1, 'meinen': 1, 'mein': 1, 'unser': 1, 'unsere': 1 };
  var ZAHL = /^(?:\d[\d.,\/x×*-]*[a-z²]{0,3}|dn\d*|ø\d*|mm|cm|m|m²|qm|kg|g|l|ml|x|stk|stück|liter|meter|zentimeter|millimeter|kilo|sack|säcke|rolle|rollen|paket)$/;
  var MENGE = /^(?:\d+[.,]?\d*\s*(?:m|m2|m²|qm|lfm|stk|stück|sack|säcke|rollen?|pakete?|paletten?)|m|m2|m²|qm|lfm|stk|stück)$/;
  var BEIWORT = /^[a-zäöüß]{3,}(?:fest|sicher|bar|ig|lich|isch|sam|los|haft|frei|dicht|iert|ert|end)(?:e|er|es|en|em)$/;
  var KOEPFE_ZERLEGEN = ['bretter', 'brett', /* C 11.10. 17:37: „Holzbretter“ */ 'bürsten', 'bürste', 'garnitur', 'stufen', 'stufe', 'folie', 'folien', 'platten', 'platte', 'farbe', 'kleber',
    'schrauben', 'schraube', 'leiste', 'leisten', 'rohr', 'profil', 'steine', 'stein', 'lampe', 'leuchte', 'matte', 'band', 'schlauch'];
  var KOEPFE_KURZ = ['farbe', 'pinsel', 'kleber', 'platten', 'platte', 'profil', 'schrauben', 'schraube', 'fliesen', 'fliese', 'dübel',
    'lack', 'mörtel', 'putz', 'folie', 'band', 'rohr', 'leiste', 'steine', 'stein', 'kabel', 'leuchte', 'rolle',
    'roller', 'scheibe', 'säge', 'bohrer', 'zange', 'latte', 'tür', 'fenster', 'dämmung'];
  /* C 12.10. 13:37: Kopfwort selbst („kleber“) oder Kompositum darauf („steckdose“ → „dose“, mind. 3 Zeichen davor) — Live:
     „gira steckdose“ (Gira führen wir nicht) zeigte Badbox/Rucksack, weil Meilisearch „steckdose“ zuerst wegließ. */
  var KOEPFE_KURZ_KOMPOSITUM = ['dose', 'schere', 'wanne', 'matte', 'tuch', 'erde', 'kleber', 'schutz']; /* C 16.10. 13:37: + kleber/schutz (Live: „Code Power RX4 Flexkleber“ zeigte ein Wand-WC, „Spiegel kantenschutz“ nur Kosmetikspiegel, weil der Kopf zuerst wegfiel) */ /* C 14.10. 13:37: + erde (Live: „Compo sana rasenerde“ zeigte Blumenerde, weil die Rasenerde zuerst wegfiel) */ /* C 12.10. 17:37: + matte/tuch (Live: „Kerdi Entkopplungsmatte“ zeigte nur den Kerdi-Rost, weil die Matte zuerst wegfiel) */
  function kopfAmEnde(w) {
    if (KOEPFE_KURZ.indexOf(w) >= 0) return true;
    if (w.length >= 4 && FORM_BUCHSTABEN.indexOf(w.charAt(0)) >= 0 && formKopf(w.slice(1)) === w.slice(1)) return true; /* C 16.10. 13:37: geklebtes Formteil („uprofil“, „lstein“) ist Kopf (Live: „precit u profil“ zeigte nur Precit-Schrauben) */
    for (var k = 0; k < KOEPFE_KURZ_KOMPOSITUM.length; k++) { var h = KOEPFE_KURZ_KOMPOSITUM[k]; if (w.length - h.length >= 3 && w.slice(-h.length) === h) return true; }
    return false;
  } /* /C 12.10. 13:37 */
  // „wand- und deckenfarbe“ → „wandfarbe deckenfarbe“ (Ergänzungsstrich auflösen)
  function ergaenzen(q) {
    var toks = String(q).toLowerCase().trim().split(/\s+/);
    return toks.map(function (t, i) {
      if (t.length > 2 && t.charAt(t.length - 1) === '-') {
        var rest = toks.slice(i + 1).filter(function (x) { return ['und', 'oder', '&', ','].indexOf(x) < 0; });
        var kopf = null;
        if (rest.length) for (var k = 0; k < KOEPFE_KURZ.length; k++) { var h = KOEPFE_KURZ[k]; if (rest[0].slice(-h.length) === h) { kopf = h; break; } }
        return t.slice(0, -1) + (kopf || '');
      }
      return t;
    }).join(' ');
  }
  // „50/50/4“ (Platten, Bordsteine) = 50x50x4 → „50x50 50x50x4“ (gleiches Format zuerst, die Dicke danach);
  // „50/50“ nur ab 20 — „2/5“, „0/32“, „8/16“ sind Körnungen und bleiben.
  function schraegMass(t) {
    var m = /^(\d+(?:[.,]\d+)?)\/(\d+(?:[.,]\d+)?)(?:\/(\d+(?:[.,]\d+)?))?$/.exec(t);
    if (!m) return [t];
    if (m[3]) return [m[1] + 'x' + m[2], m[1] + 'x' + m[2] + 'x' + m[3]];
    if (parseFloat(m[1]) >= 20 && parseFloat(m[2]) >= 20) return [m[1] + 'x' + m[2]];
    return [t];
  }
  /* C 21:37: Formbuchstabe vor Formteil („l stein“, „L-Stein“, „u profil“, „t stück“) → „lstein“ wie im Index (L-Stein,
     U-Profil, T-Stück tragen dort „lstein“, „uprofil“, „tstück“); Kompositum: „l bausteine“ → „lsteine bausteine“.
     Nicht hinter einer Zahl („50 l“ = Liter). Live 11.10.: „L stein“ zeigte Kalksand-Plansteine „L 12“. */
  var FORM_BUCHSTABEN = ['l', 'u', 't', 'h', 'y', 'z'];
  var FORM_KOEPFE = ['steine', 'stein', 'profile', 'profil', 'stück', 'schalen', 'schale', 'schiene'];
  function formKopf(w) {
    for (var k = 0; k < FORM_KOEPFE.length; k++) { var h = FORM_KOEPFE[k]; if (w === h || (w.length - h.length >= 3 && w.slice(-h.length) === h)) return h; }
    return null;
  }
  function buchstabenKleben(toks) {
    var aus = [];
    for (var i = 0; i < toks.length; i++) {
      var t = toks[i], w = toks[i + 1] || '', kopf;
      if (FORM_BUCHSTABEN.indexOf(t) >= 0 && !(aus.length && /\d/.test(aus[aus.length - 1])) && /^[a-zäöüß]{3,}$/.test(w) && (kopf = formKopf(w))) {
        aus = aus.concat(w === kopf ? [t + w] : [t + kopf, w]); i++; continue;
      }
      aus.push(t);
    }
    return aus;
  } /* /C 21:37 */
  function woerter(q) {
    var aus = [];
    q = String(q).replace(/(\d)\s*[x×*]\s*(?=\d)/gi, '$1x'); /* C 12.10. 17:37: „20 X20“, „20 x 20“ → „20x20“ wie im Index (Live: „Bodenfliese 20 X20“) */
    ergaenzen(q).split(/\s+/).forEach(function (t) {
      t = t.replace(/^[,.;:!?"'()]+|[,.;:!?"'()]+$/g, '');
      if (FORM_BUCHSTABEN.indexOf(t.charAt(0)) >= 0 && /^[a-z]-[a-zäöüß]{3,}$/.test(t) && formKopf(t.slice(2))) aus = aus.concat([t.charAt(0), t.slice(2)]); /* C 21:37 */
      // Bindestrich-Komposita: Kopf (hinten) zuerst — „feuchtraum-wandfarbe“ → „wandfarbe feuchtraum“
      else if (t.replace(/^-+|-+$/g, '').indexOf('-') > 0 && !/^[\d.,]+-/.test(t)) aus = aus.concat(t.split('-').reverse());
      else { var gm = /^([a-zäöüß]{4,})(\d[\d.,]*)$/.exec(t); /* C 16.10. 13:37: Wort+Zahl geklebt („maßband50“) → zwei Wörter (Live: „stahl maßband50“ zeigte Stahlzargen) */
        aus = aus.concat(gm ? [gm[1], gm[2]] : schraegMass(t)); }
    });
    return buchstabenKleben(aus.filter(Boolean));
  }
  function umstellen(q) { var t = umstellenTeile(q); return t.roh != null ? t.roh : t.kern.concat(t.zahlen, t.zusatz, t.weich, t.mengen).join(' '); } /* M 29.10.: Teile für die Markenregel, Ausgabe unverändert */
  function umstellenTeile(q) {
    var toks = woerter(q), kern = [], zahlen = [], zusatz = [], weich = [], mengen = [], imZusatz = false;
    toks.forEach(function (t, i) {
      if (i > 0 && SCHNITT[t]) { imZusatz = true; return; }
      if (STOPP[t]) return;
      if (MENGE.test(t)) mengen.push(t);
      else if (WEICH.test(t)) weich.push(t);
      else if (ZAHL.test(t)) zahlen.push(t);
      else if (imZusatz) zusatz.push(t);
      else kern.push(t);
    });
    if (!kern.length) return { roh: String(q).toLowerCase().trim() };
    var vorn = kern.filter(function (t, i) { return i < kern.length - 1 && t.length >= 8 && BEIWORT.test(t); });
    if (vorn.length && vorn.length < kern.length) kern = kern.filter(function (t) { return vorn.indexOf(t) < 0; }).concat(vorn);
    /* C 12.10. 08:52: Steht als letztes Kernwort ein Kopfwort („substrat flex kleber“), kommt es nach vorn, das nächststehende
       Bestimmungswort danach („kleber flex substrat“) — Meilisearch lässt sonst den Kopf zuerst weg (Live: Blumenerde vorn). */
    if (kern.length >= 2 && kopfAmEnde(kern[kern.length - 1])) kern = [kern[kern.length - 1]].concat(kern.slice(0, -1).reverse());
    return { kern: kern, zahlen: zahlen, zusatz: zusatz, weich: weich, mengen: mengen };
  }
  var MASS3 = /^(\d+(?:[.,]\d+)?x\d+(?:[.,]\d+)?)x\d+(?:[.,]\d+)?[a-z]{0,2}$/;
  function anfrageVarianten(q) {
    var toks = String(q).toLowerCase().trim().split(/[\s\-]+/).filter(Boolean), ganz = toks.join(' '), aus = [];
    function dazu(l) { var s = l.join(' ').trim(); if (s && s !== ganz && aus.indexOf(s) < 0) aus.push(s); }
    /* C 21:37: Wort+Nummer zusammengeklebt („leinölfirnis2069667“) → zwei Wörter */
    toks = toks.reduce(function (a, t) { var m = /^([a-zäöüß]{4,})(\d[\d.,]*)$/.exec(t) || /^(\d{3,})([a-zäöüß]{4,})$/.exec(t); return a.concat(m ? [m[1], m[2]] : [t]); }, []);
    /* C 12.10. 08:52: Marke+Akku+Ware zusammengetippt („einhellakuheckenschere“, „einhellakuhe“) → „einhell akku heckenschere“;
       zuerst alle Wörter, dann nur das zerlegte Wort (ein unbekanntes Typkürzel daneben – „MZK 20V“ – soll nicht alles leeren). */
    var akku = [];
    toks = toks.reduce(function (a, t) { var m = /^([a-zäöüß]{3,}?)(akku|aku)([a-zäöüß]{2,})$/.exec(t) || /^()(akku|aku)([a-zäöüß]{4,})$/.exec(t); if (!m) return a.concat([t]); var z = [m[1], 'akku', m[3]].filter(Boolean); akku.push(z); return a.concat(z); }, []);
    if (akku.length) { dazu(toks.filter(function (t) { return !WEICH.test(t); })); akku.forEach(function (z) { dazu(z); if (z.length === 3) dazu(z.slice(1)); }); } /* /C 12.10. */
    var t1 = toks.filter(function (t) { return !WEICH.test(t); }); if (!t1.length) t1 = toks;
    dazu(t1);
    /* C 21:37: Länge am Maß weglassen („7x7x210cm“ → „7x7“) — der Index kennt Querschnitt und Querschnitt×Länge */
    if (t1.some(function (t) { return MASS3.test(t); })) dazu(t1.map(function (t) { var m = MASS3.exec(t); return m ? m[1] : t; }));
    var links = t1;
    for (var i = 1; i < t1.length; i++) if (SCHNITT[t1[i]]) { links = t1.slice(0, i); break; }
    dazu(links);
    var t2 = links.filter(function (t) { return !ZAHL.test(t); }); if (!t2.length) t2 = links;
    dazu(t2);
    for (var j = 1; j < t2.length; j++) dazu(t2.slice(j));
    // Langes Kompositum ohne Treffer zerlegen: „splitterschutzfolie“ → „splitterschutz folie“, „splitterschutz“, „folie“
    t2.forEach(function (t, i) {
      for (var k = 0; k < KOEPFE_ZERLEGEN.length; k++) {
        var h = KOEPFE_ZERLEGEN[k];
        if (t.length >= 10 && t.slice(-h.length) === h && t.length - h.length >= 4) {
          var vorn = t.slice(0, -h.length).replace(/s$/, '');
          dazu(t2.slice(0, i).concat([vorn, h], t2.slice(i + 1)));
          dazu(t2.slice(0, i).concat([vorn], t2.slice(i + 1)));
          dazu([h]);
          break;
        }
      }
    });
    // Tippfehler am Wortende („farbromme“, „farbroölr“): Wortanfang als Präfix suchen
    var letzt = t2[t2.length - 1];
    if (letzt && letzt.length >= 8 && /^[a-zäöüß]+$/.test(letzt)) dazu(t2.slice(0, -1).concat([letzt.slice(0, Math.max(5, letzt.length - 3))]));
    return aus.slice(0, 8);
  }
  /* K: Bedeutungssuche (hybride Suche, nur wenn CFG.bedeutung gesetzt = Test-Shop) ---------------------------------
     Letzte Stufe: nur wenn die Wortsuche UND die Wortvarianten nichts finden. Meilisearch holt den Anfragevektor selbst
     beim Dienst „suche-embed“ (Railway EU, Kostenlimit, Cache). Gezeigt wird nur, was der Bedeutung nach sicher passt
     (Top-Ähnlichkeit ≥ CFG.bedeutung.schwelle, gemessen 0,80 → Unsinn wie „xyzqwv“/„pizza“ bleibt leer).
     12.10. (Freigabe Dennis): zweite Stufe „Vielleicht meinten Sie:“ ab CFG.bedeutung.vielleicht (0,76), aber nur mit klarem
     Sieger — Top-1 mindestens CFG.bedeutung.abstand (0,02) über Platz 10. Gemessen über 71 Anfragen (Live-0-Treffer, Varianten,
     20 Unsinn): richtige Top-1 17 → 23 von 25, falsche 4 → 6, Unsinn 0 → 0 (Bericht SCR/agent-k/bericht.md).
     Artikelnummern, EAN und Codes („c1282“) gehen nie über diesen Weg. Fehler/Zeitüberschreitung → wie bisher 0 Treffer. */
  var BEDEUTUNG_ZEIT = 1500;
  function bedeutungSuche(q, basis, signal) {
    var B = CFG.bedeutung;
    if (!B || istNummer(q) || String(q).toLowerCase().split(/\s+/).some(function (t) { return /^[a-z]{0,3}\d{3,}[a-z]?$/.test(t) || /\d{4,}/.test(t); })) return Promise.resolve(null);
    var b = {}; for (var k in basis) if (k !== 'facets' && k !== 'matchingStrategy') b[k] = basis[k];
    b.q = umstellen(q); b.limit = Math.max(basis.limit || 0, 10); b.attributesToRetrieve = basis.attributesToRetrieve || ['handle'];
    b.hybrid = { embedder: B.embedder || 'bedeutung', semanticRatio: 1 }; b.showRankingScore = true;
    var schwelle = B.schwelle || 0.8, vielleicht = B.vielleicht || schwelle, abstand = B.abstand || 0;
    var zeit = new Promise(function (ok) { setTimeout(function () { ok(null); }, BEDEUTUNG_ZEIT); });
    return Promise.race([anfrage([b], signal).then(function (r) {
      var hits = ((r[0] || {}).hits || []);
      if (!hits.length) return null;
      var top = hits[0]._rankingScore || 0, zehn = (hits[Math.min(9, hits.length - 1)] || {})._rankingScore || 0;
      var stufe = top >= schwelle ? 'aehnlich' : (top >= vielleicht && top - zehn >= abstand ? 'vielleicht' : null);
      if (!stufe) return null;
      var unten = Math.min(schwelle, top) - 0.03;
      hits = hits.filter(function (h) { return (h._rankingScore || 0) >= unten; }).slice(0, basis.limit || 6);
      var fd = {};
      (basis.facets || []).forEach(function (f) { fd[f] = {}; hits.forEach(function (h) { if (h[f] != null && h[f] !== '') fd[f][h[f]] = (fd[f][h[f]] || 0) + 1; }); });
      return { hits: hits, estimatedTotalHits: hits.length, totalHits: hits.length, totalPages: 1, facetDistribution: fd, stufe: stufe };
    }).catch(function () { return null; }), zeit]);
  }
  /* /K */
  /* M: Markenregel 29.10. (Freigabe Dennis) ---------------------------------------------------------------------
     Greift NUR, wenn kein Artikel ALLE Wörter trägt (eigene Zählabfrage „alle Wörter“). Sonst lässt der Suchdienst von
     hinten weg — oft das Typwort oder das Maß („Bosch akku laubbläser“ → nur Bosch-Ware). Betrachtet werden nur Kernwörter
     und Maße (Zusatz nach „für/mit …“, Farben, Mengen fallen wie bisher zuerst weg). Jedes Wort wird aus dem Index
     eingestuft (nichts fest verdrahtet), weggelassen werden höchstens Wörter der Stufen 0–3, in dieser Reihenfolge:
       0 kein Treffer · 1 nur Tippfehler-/Wortanfang-Treffer und entweder ähnlich einer Marke („Wera“ → WEXA/WEMA) oder
       kürzer als 4 Zeichen („uns“) · 2 Kürzel aus 1–2 Buchstaben („Z GP“; nie Zahlen/Einheiten) · 3 Marke (steht genau so im Feld „marke“)
       oder Markenlinie (alle Artikel mit dem Wort sind EINER Marke, die nicht in der Anfrage steht: „Precision“).
     Eine Marke/Linie fällt nur weg, wenn sie zusammen mit den Typwörtern keinen Artikel hat (sonst bleibt sie).
     Sonstige Wörter, Maße und Typwörter (Stufen 4–6) lässt die Regel nie weg. Gewählt wird die Fassung mit der
     niedrigsten höchsten Stufe, dann möglichst wenigen Wörtern weniger, dann von hinten. Trägt schon der Kern einen
     Artikel oder entspricht die Fassung „Wörter von hinten weg“, bleibt alles wie bisher. Ein Wort ohne Treffer ab
     9 Buchstaben wird als Wortanfang versucht („baumpfäle“ → „baumpf…“). Hinweis: „Keine (passenden) Artikel von X gefunden“. */
  var MK_TYP = ['typ_titel', 'typ', 'zerlegt'], mkCache = {};
  function mkWoerter(q2) { return String(q2).split(/\s+/).filter(Boolean); }
  function mkAnfang(w) { return w.length >= 9 && w.length <= 11 && /^[a-zäöüß]+$/.test(w) ? w.slice(0, w.length - 2) : null; } /* 7–9 Buchstaben Wortanfang (1 Tippfehler) */
  function mkEinstufen(ws, idx, signal) {
    var neu = ws.filter(function (w, i) { var c = mkCache[idx + '|' + w]; return (!c || c.nurHier) && ws.indexOf(w) === i; }), qs = [];
    neu.forEach(function (w) {
      /* „w und“: Das Stoppwort „und“ (Index-Einstellung) steht hinten, so gilt für w die Tippfehler-, aber nicht die Wortanfang-Suche. */
      var ph = '"' + w.replace(/"/g, '') + '"', an = mkAnfang(w), np = w + ' und';
      qs.push({ indexUid: idx, q: w, limit: 0 }, { indexUid: idx, q: ph, limit: 0 },
        { indexUid: idx, q: ph, limit: 0, attributesToSearchOn: ['marke'], facets: ['marke'] }, { indexUid: idx, q: np, limit: 0, attributesToSearchOn: ['marke'] },
        { indexUid: idx, q: w.length < 4 ? ph : np, limit: 0, attributesToSearchOn: MK_TYP },
        { indexUid: idx, q: an || ph, limit: 0 }, { indexUid: idx, q: ph, limit: 0, attributesToSearchOn: MK_TYP },
        { indexUid: idx, q: ph, limit: 5, attributesToSearchOn: ['titel'], facets: ['marke', 'kategorie_id'], attributesToRetrieve: ['produktart'] });
    });
    if (qs.length && mkCache[idx + '|*'] == null) qs.push({ indexUid: idx, q: '', limit: 0 }); /* alle Artikel: erkennt Stoppwörter des Index */
    if (!qs.length) return Promise.resolve(ws.map(function (w) { return mkCache[idx + '|' + w]; }));
    return anfrage(qs, signal).then(function (r) {
      if (mkCache[idx + '|*'] == null) { var g = r[neu.length * 8] || {}; mkCache[idx + '|*'] = g.estimatedTotalHits || g.totalHits || 0; }
      var gesamt = mkCache[idx + '|*'];
      neu.forEach(function (w, i) {
        var n = function (k) { var x = r[i * 8 + k] || {}; return x.estimatedTotalHits || x.totalHits || 0; };
        var alle = n(0), genau = n(1), marke = n(2), markeAehnlich = n(3), typ = n(4), kl;
        var linie = Object.keys(((r[i * 8 + 7] || {}).facetDistribution || {}).marke || {}), typGenau = n(6);
        var pa = (((r[i * 8 + 7] || {}).hits) || []).some(function (h) { return (h.produktart || []).some(function (p) { p = String(p).toLowerCase(); var e = 0; while (e < p.length && e < w.length && p.charAt(p.length - 1 - e) === w.charAt(w.length - 1 - e)) e++; return p.indexOf(w) >= 0 || e >= 5; }); }); /* Wort ist (ein Kompositum auf) die Produktart seiner Treffer: „Stemmhammer“ ~ Abbruchhammer */
        var markenName = Object.keys(((r[i * 8 + 2] || {}).facetDistribution || {}).marke || {}).filter(function (m) { return String(m).toLowerCase().split(/[\s\-.&\/]+/)[0] === w; })[0] || null; /* Wort = erstes Wort eines Markennamens */
        if (gesamt && genau >= gesamt) kl = -1; /* Stoppwort des Index („artikel“: genau so = alle Artikel): zählt nicht */
        else if (!alle) kl = 0;
        else if (!genau && (markeAehnlich > 0 || w.length < 4)) kl = 1;
        else if (ZAHL.test(w) || MENGE.test(w)) kl = 5; /* Maße, Zahlen, Einheiten („dn“) */
        else if (/^[a-zäöüß]{1,2}$/.test(w)) kl = 2; /* Kürzel aus 1–2 Buchstaben */
        else if (marke > 0 && markenName && w.length >= 3 && !typGenau && !pa) kl = 3; /* „Klinker“, „Licht“, „LED“ sind auch Produktarten → keine Marke */
        else if (typGenau > 0 || pa || (typ > 0 && !genau)) kl = 6;
        else if (linie.length === 1 && w.length >= 4 && genau <= 30 && !String(linie[0]).toLowerCase().split(/[\s\-.&\/]+/).some(function (x) { return x !== w && ws.indexOf(x) >= 0; })) kl = 3; /* Linie einer Marke, die nicht in der Anfrage steht */
        else kl = 4;
        mkCache[idx + '|' + w] = { w: w, kl: kl, nurHier: linie.length === 1, marke: kl === 3 && marke > 0 || (kl === 1 && markeAehnlich > 0 && !genau && w.length >= 4), unbekannt: kl === 1,
          name: markenName, sach: genau > 0 && (kl === 6 && w.length >= 4 || kl === 4 && w.length >= 6), /* behaltenes Sachwort: genau so im Index; Typwort ab 4, sonstiges ab 6 Zeichen („honig“, „polar“ reichen nicht) */
          kat: Object.keys(((r[i * 8 + 7] || {}).facetDistribution || {}).kategorie_id || {}),
          von: linie.length === 1 ? String(linie[0]).toLowerCase().split(/[\s\-.&\/]+/) : [], anfang: !alle && mkAnfang(w) && n(5) > 0 && n(5) <= 5 ? mkAnfang(w) : null }; /* Wortanfang nur, wenn er eng trifft (≤ 5 Artikel) */
      });
      return ws.map(function (w) { return mkCache[idx + '|' + w]; });
    });
  }
  function mkKandidaten(info) {
    var n = info.length, aus = [];
    if (n < 2 || n > 7) return aus;
    for (var m = 1; m < (1 << n); m++) {
      var weg = [], bleib = [], hoch = -1, summe = 0, pos = 0, sach = false, anfang = null;
      for (var i = 0; i < n; i++) {
        if (m & (1 << i)) {
          if (info[i].anfang && !anfang) { anfang = info[i].anfang; weg.push(info[i]); continue; } /* Wortanfang statt ganzem Wort, steht am Ende */
          weg.push(info[i]); hoch = Math.max(hoch, info[i].kl); summe += info[i].kl; pos += i;
        } else { if (!info[i].kl) { bleib = null; break; } bleib.push(info[i].w); if (info[i].sach) sach = true; } /* Wort ohne Treffer bleibt nie */
      }
      if (!bleib) continue;
      if (weg.some(function (x) { return x.name && info.some(function (y, j) { return !(m & (1 << j)) && y.w !== x.w && String(x.name).toLowerCase().split(/[\s\-.&\/]+/).indexOf(y.w) >= 0; }); })) continue; /* Teil desselben Markennamens bleibt nicht allein („Tex-Color“) */
      if (weg.some(function (x) { return x.kl === 3; }) && info.some(function (x, i) { return !(m & (1 << i)) && x.von.some(function (v) { return weg.some(function (y) { return y.kl === 3 && y.w === v; }); }); })) continue; /* Linie der weggelassenen Marke bleibt nicht allein stehen („Compo sana“) */
      if (anfang) { bleib.push(anfang); sach = true; }
      if (!bleib.length || !sach || hoch > 3) continue;
      if (weg.filter(function (x) { return x.kl === 2; }).length > bleib.length) continue; /* nicht mehr Kürzel/Zahlen weg, als Wörter bleiben („ht dn 75 winkel“) */
      aus.push({ q: bleib.join(' '), weg: weg, hoch: hoch, anzahl: weg.length - (anfang ? 1 : 0), summe: summe, pos: pos, anfang: !!anfang });
    }
    aus.sort(function (a, b) { return a.hoch - b.hoch || a.anzahl - b.anzahl || a.summe - b.summe || (a.anfang ? 1 : 0) - (b.anfang ? 1 : 0) || b.pos - a.pos; });
    var gesehen = {};
    return aus.filter(function (k) { if (gesehen[k.q]) return false; gesehen[k.q] = 1; return true; }).slice(0, 10);
  }
  function mkMarkenText(weg, q, fd) {
    var roh = String(q).split(/\s+/), da = Object.keys(fd || {}).join(' ').toLowerCase().split(/[\s\-.&\/]+/);
    var m = weg.filter(function (x) { return x.marke && da.indexOf(x.w) < 0; })[0]; /* Marke steht unter den Treffern → kein Markenhinweis */
    if (!m) return '';
    var klein = roh.map(function (t) { return t.toLowerCase().replace(/^[,.;:!?"'()]+|[,.;:!?"'()]+$/g, ''); });
    var name = m.name && String(m.name).toLowerCase().split(/[\s\-.&\/]+/).filter(Boolean).every(function (x) { return klein.indexOf(x) >= 0; }) ? m.name : null; /* voller Markenname nur, wenn er so in der Anfrage steht */
    var orig = name || roh[klein.indexOf(m.w)] || m.w;
    return (m.unbekannt ? 'Keine Artikel von ' : 'Keine passenden Artikel von ') + orig + ' gefunden';
  }
  function markenRegel(q, q2, basis, signal, nullTreffer) {
    var t = umstellenTeile(q);
    if (t.roh != null) return Promise.resolve(null);
    var ws = t.kern.concat(t.zahlen);
    if (ws.length < 2 || ws.length > 7 || istNummer(q) || ws.some(function (w) { return !/^[a-zäöüß0-9][a-zäöüß0-9.,\/x×²-]*$/.test(w); })) return Promise.resolve(null); /* Sonderzeichen („Profil(Lotprofil“): wie bisher */
    function mit(o) { var x = {}; for (var k in basis) x[k] = basis[k]; for (var j in o) x[j] = o[j]; return x; }
    var idx = basis.indexUid;
    return mkEinstufen(ws, idx, signal).then(function (info) {
      info = info.filter(function (x) { return x.kl !== -1; }); ws = info.map(function (x) { return x.w; });
      if (info.some(function (x) { return !x.kl && /\d/.test(x.w); })) return null; /* kaputtes Maß („50cmx50cmx“): Zahlen unsicher, wie bisher */
      if (nullTreffer && info.some(function (x) { return !x.kl && x.w.length >= 8 && !x.anfang; })) return null; /* 0 Treffer und ein langes unbekanntes Wort (meist die Ware selbst): nichts Halbes zeigen */
      var ks = mkKandidaten(info);
      if (!ks.length) return null;
      /* Marke/Linie passt zu den Typwörtern? Dann darf sie nicht weg. */
      var typ = info.filter(function (x) { return x.kl === 6; }).map(function (x) { return x.w; })
        .concat(info.filter(function (x) { return x.anfang; }).map(function (x) { return x.anfang; }));
      if (!typ.length) typ = info.filter(function (x) { return x.kl === 4; }).map(function (x) { return x.w; });
      var mk = info.filter(function (x) { return x.kl === 3; });
      var pruef = [{ indexUid: idx, q: ws.join(' '), limit: 0, matchingStrategy: 'all' }, { indexUid: idx, q: typ.join(' ') || ws.join(' '), limit: 0, matchingStrategy: 'all', facets: ['kategorie_id'] }]
        .concat(mk.map(function (x) { return { indexUid: idx, q: [x.w].concat(typ).join(' '), limit: 0, matchingStrategy: 'all' }; }));
      var fac = (basis.facets || []).indexOf('marke') >= 0 ? basis.facets : (basis.facets || []).concat(['marke']);
      return anfrage(pruef.concat(ks.map(function (k) { return mit({ q: k.q, matchingStrategy: 'all', facets: fac }); })), signal).then(function (r) {
        var zahl = function (x) { return (x || {}).estimatedTotalHits || (x || {}).totalHits || 0; };
        if (zahl(r[0])) return null; /* Kern + Maße tragen einen Artikel: der Suchdienst findet ihn wie bisher */
        var bleibt = {}, typKat = ((r[1] || {}).facetDistribution || {}).kategorie_id || {};
        mk.forEach(function (x, i) { if (zahl(r[2 + i])) bleibt[x.w] = 1; if (!x.name && x.kat.some(function (k) { return typKat[k]; })) bleibt[x.w] = 1; }); /* Linie aus derselben Kategorie wie die Ware („Türbeschlag“ ~ Schiebetür) bleibt */
        r = r.slice(pruef.length);
        for (var i = 0; i < r.length; i++) {
          var k = ks[i];
          if (k.weg.some(function (x) { return bleibt[x.w]; })) continue;
          if (zahl(r[i]) > 0) {
            if (!k.anfang && ws.slice(0, mkWoerter(k.q).length).join(' ') === k.q) return null; /* = Wörter von hinten weg: wie bisher */
            return { res: r[i], q: k.q, hinweis: mkMarkenText(k.weg, q, (r[i].facetDistribution || {}).marke) };
          }
        }
        return null;
      });
    }).catch(function () { return null; });
  }
  /* /M */
  // Sucht q (umgestellt); ohne Treffer kürzere Fassungen in EINER Anfrage. Ergebnis: {res, genutzt, ersatz}
  function sucheMitRueckfall(q, basis, extra, signal) {
    var q2 = umstellen(q);
    function mit(o) { var x = {}; for (var k in basis) x[k] = basis[k]; for (var j in o) x[j] = o[j]; return x; }
    var mkPruef = mkWoerter(q2).length >= 2 && mkWoerter(q2).length <= 7 && !istNummer(q); /* M: Zählabfrage „alle Wörter“ */
    return anfrage([mit({ q: q2 })].concat(extra || [], mkPruef ? [{ indexUid: basis.indexUid, q: q2, matchingStrategy: 'all', limit: 0 }] : []), signal).then(function (res) {
      var mkAlle = mkPruef ? res.pop() : null; /* M */
      if ((res[0].estimatedTotalHits || res[0].totalHits || 0) > 0) {
        if (!mkAlle || (mkAlle.estimatedTotalHits || mkAlle.totalHits || 0) > 0) return { res: res, genutzt: q, ersatz: false };
        return markenRegel(q, q2, basis, signal).then(function (m) { /* M: niemand trägt alle Wörter */
          if (!m) return { res: res, genutzt: q, ersatz: false };
          res[0] = m.res; return { res: res, genutzt: m.q, ersatz: true, markenHinweis: m.hinweis };
        });
      }
      var vs = anfrageVarianten(q);
      var bed = bedeutungSuche(q, basis, signal); /* K: parallel zu den Wortvarianten, genutzt nur, wenn die nichts finden */
      function mitBedeutung() { return bed.then(function (p) { if (p) { res[0] = p; return { res: res, genutzt: q, ersatz: false, bedeutung: true, stufe: p.stufe }; } return markenRegel(q, q2, basis, signal, true).then(function (m) { if (m) { res[0] = m.res; return { res: res, genutzt: m.q, ersatz: true, markenHinweis: m.hinweis }; } return { res: res, genutzt: q, ersatz: false }; }); }); } /* K; M 29.10.: erst wenn auch die Bedeutungssuche nichts hat */
      if (!vs.length) return mitBedeutung(); /* K */
      return anfrage(vs.map(function (v) { return mit({ q: v, matchingStrategy: 'all' }); }), signal).then(function (r2) {
        for (var i = 0; i < r2.length; i++) {
          if ((r2[i].estimatedTotalHits || r2[i].totalHits || 0) > 0) {
            /* K: Blieb vom Kompositum nur das nackte Kopfwort („gehsteigplatten“ → „platten“), gewinnt eine SICHERE Bedeutungssuche
               (→ Gehwegplatten); sonst die Wortvariante wie bisher. Gemessen: 439er-Liste unverändert, unbekannte Kundenwörter 50 → 73 %. */
            if (KOEPFE_ZERLEGEN.indexOf(vs[i]) >= 0 && String(q).toLowerCase().split(/[\s\-]+/).indexOf(vs[i]) < 0) {
              var treffer = r2[i], genutzt = vs[i];
              return bed.then(function (p) { if (p) { res[0] = p; return { res: res, genutzt: q, ersatz: false, bedeutung: true, stufe: p.stufe }; } res[0] = treffer; return { res: res, genutzt: genutzt, ersatz: true }; });
            } /* /K */
            res[0] = r2[i]; return { res: res, genutzt: vs[i], ersatz: true };
          }
        }
        return mitBedeutung(); /* K */
      });
    });
  }

  // ---------------------------------------------------------------- Karten
  function energieHtml(e) {
    if (!e || !e.klasse) return '';
    var k = String(e.klasse).trim().toUpperCase();
    var cls = 'mb-eprel mb-eprel--' + esc(k.charAt(0).toLowerCase());
    var pfeil = e.label
      ? '<a href="' + esc(e.label) + '" target="_blank" rel="noopener" class="' + cls + '" aria-label="Energieeffizienzklasse ' + esc(k) + ' – Energielabel öffnen">' + esc(k) + '</a>'
      : '<span class="' + cls + '" aria-label="Energieeffizienzklasse ' + esc(k) + '">' + esc(k) + '</span>';
    var blatt = e.blatt ? '<a class="mb-card__sheet" href="' + esc(e.blatt) + '" target="_blank" rel="noopener">Produktdatenblatt</a>' : '';
    return '<div class="mb-card__eprel">' + pfeil + blatt + '</div>';
  }
  function lagerHtml(h) {
    /* Streckenware (Biohort 12.10.2026): Bestand beim Hersteller, Lieferung frei Haus */
    if (h.strecke && h.verfuegbar) return '<span class="mb-dot mb-dot--green"></span>Lieferbar<span class="mb-card__pickup">· frei Haus ab Hersteller</span>';
    /* Zentrallager (13.10.2026): zl = Menge (0 = ohne Zahl) oder null; zl_uebach = auch in Übach vorrätig */
    if (h.verfuegbar && h.zl !== null && h.zl !== undefined) {
      var eh = function (n) { return esc(n === 1 ? (h.bestand_einheit1 || h.bestand_einheit || 'Stück') : (h.bestand_einheit || 'Stück')); };
      var z = h.zl_uebach ? '<span class="mb-card__ue" style="flex:1 0 100%;display:flex;align-items:flex-start;gap:6px"><span class="mb-dot mb-dot--green" style="flex:0 0 auto;margin-top:4px"></span><span>' + (h.bestand > 0 ? 'Auf Lager in Übach: ' + Number(h.bestand).toLocaleString('de-DE') + '\u00a0' + eh(h.bestand) : 'Auf Lager in Übach') + '</span></span>' : '';
      z += '<span class="mb-card__zl' + (h.zl_uebach ? '' : ' mb-card__zl--allein') + '" style="flex:1 0 100%;display:flex;align-items:flex-start;gap:6px;margin-top:' + (h.zl_uebach ? '3px' : '0') + '"><span class="mb-dot mb-dot--zl" style="background:#1f6fb2;flex:0 0 auto;margin-top:4px"></span><span>Vorrätig im Zentrallager' +
        (h.zl > 0 ? ': ' + Number(h.zl).toLocaleString('de-DE') + '\u00a0' + eh(h.zl) : '') + '<span class="mb-card__zlab" data-mbzl-ab hidden></span></span></span>';
      if (h.abholung) z += '<span class="mb-card__pickup">· nur Abholung</span>';
      return z;
    }
    var s = h.verfuegbar
      ? '<span class="mb-dot mb-dot--green"></span>' + (h.bestand > 0 ? Number(h.bestand).toLocaleString('de-DE') + '\u00a0' + esc(h.bestand === 1 ? (h.bestand_einheit1 || h.bestand_einheit || 'Stück') : (h.bestand_einheit || 'Stück')) + ' auf Lager' : 'Auf Lager') /* A: genaue Menge */
      : '<span class="mb-dot mb-dot--grey"></span>Derzeit nicht vorrätig';
    if (h.abholung) s += '<span class="mb-card__pickup">· nur Abholung</span>';
    return s;
  }
  function karteHtml(h, q) {
    var url = produktUrl(h, q);
    var bild = h.bild
      ? '<img data-ms-handle="' + esc(h.handle) + '" data-ms-breite="360" src="' + esc(bildUrl(h.bild, 360)) + '" srcset="' + esc(bildUrl(h.bild, 240)) + ' 240w, ' + esc(bildUrl(h.bild, 360)) + ' 360w, ' + esc(bildUrl(h.bild, 540)) + ' 540w" sizes="(min-width: 1200px) 260px, (min-width: 768px) 30vw, 46vw" alt="' + esc(h.titel) + '" loading="lazy" width="360" height="360">'
      : '<span class="mb-card__noimg"><svg aria-hidden="true" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="2"/><path d="m21 17-5-5-9 8"/></svg><small>Kein Bild vorhanden</small></span>';
    var sale = h.vergleichspreis && h.vergleichspreis > h.preis;
    var badge = sale
      ? '<span class="mb-card__badge mb-card__badge--sale">−' + Math.max(1, Math.floor((h.vergleichspreis - h.preis) * 100 / h.vergleichspreis)) + ' %</span>'
      : (h.angebot ? '<span class="mb-card__badge mb-card__badge--sale">Angebot</span>' : '');
    var preis = '<p class="mb-card__price' + (sale ? ' is-sale' : '') + '">' + (h.preis_max > h.preis ? '<span class="mb-card__from">ab</span> ' : '') +
      euro(h.preis) + (h.preiseinheit ? '&nbsp;/&nbsp;' + esc(h.preiseinheit) : '') + /* A: Preiseinheit */ (sale ? '<s class="mb-card__compare">' + euro(h.vergleichspreis) + '</s>' : '') + '</p>';
    var aktion;
    // „Nur Abholung“-Ware: erst auf der Produktseite in den Warenkorb (Abholhinweis lesen; Shop führt sie dort korrekt).
    if (h.verfuegbar && h.variante_id && !h.abholung) {
      aktion = '<form method="post" action="/cart/add" class="mb-card__form" data-mb-quickadd><input type="hidden" name="id" value="' + esc(h.variante_id) + '"><input type="hidden" name="quantity" value="1">' +
        (h.zuschnitt ? '<input type="hidden" name="properties[Zuschnitt]" value="auf Maß geschnitten – Rückgabe und Umtausch ausgeschlossen">' : '') + /* A: Zuschnittware */
        (h.preiseinheit ? '<input type="hidden" name="properties[Einheit]" value="' + esc(h.preiseinheit_text || h.preiseinheit) + '">' : '') + /* A: Preiseinheit */
        '<button type="submit" class="mb-btn mb-btn--cart"><svg aria-hidden="true" viewBox="0 0 24 24"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="m1 1 4 4 15 1-1 9H6"/></svg><span>In den Warenkorb</span></button></form>';
    } else {
      aktion = '<a class="mb-btn mb-btn--ghost" href="' + url + '">' + (h.varianten > 1 ? 'Ausführung wählen' : 'Details ansehen') + '</a>';
    }
    return '<article class="mb-card">' +
      '<a class="mb-card__media" href="' + url + '" tabindex="-1" aria-hidden="true">' + bild + badge + '</a>' +
      '<div class="mb-card__body">' +
      (h.marke ? '<p class="mb-card__brand">' + esc(h.marke) + '</p>' : '') +
      '<h3 class="mb-card__title"><a href="' + url + '">' + esc(h.titel) + '</a></h3>' +
      (h.varianten > 1 ? '<p class="mb-card__variants">' + h.varianten + ' Ausführungen</p>' : '') +
      '<div class="mb-card__pricebox">' + energieHtml(h.energie) + preis +
      (h.grundpreis ? '<p class="mb-card__unit">' + esc(h.grundpreis) + '</p>' : '') +
      '<p class="mb-card__tax">inkl. MwSt., zzgl. <a href="/pages/versandinformationen">Versand</a></p></div>' +
      '<p class="mb-card__stock">' + lagerHtml(h) + '</p>' +
      (h.zuschnitt ? '<p class="mb-cut-chip"><span aria-hidden="true">✂</span> Zuschnitt · keine Rückgabe</p>' : '') + /* A: Zuschnittware */
      (h.biozid ? '<p class="mb-pflicht mb-pflicht--karte" style="margin:6px 0 0;padding:5px 7px;border-left:3px solid #b45309;background:#fff7ed;color:#3d2a12;font-size:12px;line-height:1.35;font-weight:600">Biozidprodukte vorsichtig verwenden. Vor Gebrauch stets Etikett und Produktinformationen lesen.</p>' : '') + /* PSM/Biozid 12.10.: Pflichthinweis Art. 72 BPR */
      '<div class="mb-card__actions">' + aktion + '</div>' +
      '</div></article>';
  }

  // ---------------------------------------------------------------- Sofortsuche (Dropdown)
  var dropId = 0;
  function Sofortsuche(form) {
    var input = form.querySelector('input[name="q"]');
    if (!input || input.__ms) return;
    input.__ms = true;
    var id = 'ms-drop-' + (++dropId);
    var drop = document.createElement('div');
    drop.className = 'ms-drop';
    drop.id = id;
    drop.hidden = true;
    drop.setAttribute('role', 'listbox');
    drop.setAttribute('aria-label', 'Suchvorschläge');
    document.body.appendChild(drop);
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', id);

    var timer = null, laufend = null, letzte = '', aktiv = -1, ergebnis = null;

    function position() {
      var r = form.getBoundingClientRect();
      var vw = document.documentElement.clientWidth;
      var mobil = vw < 768;
      var breite = mobil ? vw : Math.min(Math.max(r.width, 760), vw - 16);
      var links = mobil ? 0 : Math.max(8, Math.min(r.left, vw - breite - 8));
      drop.style.top = Math.round(r.bottom + (mobil ? 4 : 6)) + 'px';
      drop.style.left = Math.round(links) + 'px';
      drop.style.width = Math.round(breite) + 'px';
      drop.style.maxHeight = Math.max(240, window.innerHeight - r.bottom - 16) + 'px';
    }
    function oeffnen() {
      position();
      drop.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    function schliessen() {
      drop.hidden = true;
      aktiv = -1;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }
    function optionen() { return drop.querySelectorAll('[data-ms-opt]'); }
    function markieren(i) {
      var opts = optionen();
      if (!opts.length) return;
      aktiv = (i + opts.length) % opts.length;
      for (var k = 0; k < opts.length; k++) opts[k].classList.toggle('is-aktiv', k === aktiv);
      input.setAttribute('aria-activedescendant', opts[aktiv].id);
      opts[aktiv].scrollIntoView({ block: 'nearest' });
    }

    function rendern(q, res, kat, info) {
      var p = res[0], hits = p.hits || [];
      var gesamt = p.estimatedTotalHits || 0;
      var n = 0;
      function opt(html, href, cls) {
        n++;
        return '<a id="' + id + '-o' + n + '" role="option" data-ms-opt class="' + cls + '" href="' + href + '">' + html + '</a>';
      }
      // Reihenfolge nach den besten Treffern (nicht nach bloßer Menge): erst Art/Kategorie der Top-Treffer,
      // dann die häufigsten unter allen Treffern.
      function rangfolge(feld, verteilung, max, erlaubt) {
        var liste = [];
        hits.forEach(function (h) { var v = h[feld]; if (v && liste.indexOf(v) < 0 && erlaubt(v)) liste.push(v); });
        Object.keys(verteilung || {}).sort(function (a, b) { return verteilung[b] - verteilung[a]; })
          .forEach(function (v) { if (v && liste.indexOf(v) < 0 && erlaubt(v)) liste.push(v); });
        return liste.slice(0, max);
      }
      var fd = p.facetDistribution || {};
      var katIds = rangfolge('kategorie_id', fd.kategorie_id, 4, function (k) { return !!kat[k]; });
      ((res[1] || {}).hits || []).forEach(function (k) { if (katIds.indexOf(k.id) < 0 && kat[k.id]) katIds.unshift(k.id); });
      katIds = katIds.slice(0, 4);
      var vorschlaege = rangfolge('produktart_haupt', fd.produktart_haupt, 5, function (a) { return a.toLowerCase() !== q.toLowerCase(); });

      var rechts = '';
      if (hits.length) {
        rechts = '<p class="ms-drop__kopf">Produkte</p><div class="ms-drop__produkte">' + hits.map(function (h) {
          var img = h.bild ? '<img data-ms-handle="' + esc(h.handle) + '" data-ms-breite="120" src="' + esc(bildUrl(h.bild, 120)) + '" alt="" loading="lazy" width="60" height="60">' : '<span class="ms-noimg" aria-hidden="true"></span>';
          var preis = (h.preis_max > h.preis ? 'ab ' : '') + euro(h.preis) + (h.preiseinheit ? ' / ' + esc(h.preiseinheit) : ''); /* A: Preiseinheit */
          return opt('<span class="ms-prod__bild">' + img + '</span><span class="ms-prod__text"><span class="ms-prod__titel">' + esc(h.titel) + '</span>' +
            '<span class="ms-prod__meta"><strong>' + preis + '</strong>' + (h.grundpreis ? ' <small>(' + esc(h.grundpreis) + ')</small>' : '') +
            '<span class="ms-lager ' + (h.verfuegbar ? 'is-ja' : 'is-nein') + (h.zl !== null && h.zl !== undefined && !h.zl_uebach ? ' is-zl' : '') + '">' + (h.verfuegbar ? (h.strecke ? 'Lieferbar ab Hersteller' : (h.zl !== null && h.zl !== undefined && !h.zl_uebach) ? 'Im Zentrallager' : 'Auf Lager') : 'Nicht vorrätig') + '</span>' +
            (h.zuschnitt ? '<span class="mb-cut-chip ms-cut"><span aria-hidden="true">✂</span> Zuschnitt · keine Rückgabe</span>' : '') + /* C: Zuschnitt im Dropdown */
            (h.energie && h.energie.klasse ? '<span class="mb-eprel mb-eprel--' + esc(String(h.energie.klasse).trim().charAt(0).toLowerCase()) + ' ms-eprel">' + esc(String(h.energie.klasse).trim().toUpperCase()) + '</span>' : '') +
            '</span></span>', produktUrl(h, q), 'ms-prod');
        }).join('') + '</div>';
      }
      var links = '';
      if (vorschlaege.length) {
        links += '<p class="ms-drop__kopf">Suchvorschläge</p><div class="ms-drop__liste">' + vorschlaege.map(function (a) {
          return opt('<svg aria-hidden="true" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.6-3.6"/></svg><span>' + esc(a) + '</span>', suchUrl(a), 'ms-vorschlag');
        }).join('') + '</div>';
      }
      if (katIds.length) {
        links += '<p class="ms-drop__kopf">Kategorien</p><div class="ms-drop__liste">' + katIds.map(function (k) {
          var e = kat[k];
          return opt('<span>' + esc(e.name) + (e.bereich ? '<small>' + esc(e.bereich) + '</small>' : '') + '</span>', katUrl(e, q), 'ms-kat');
        }).join('') + '</div>';
      }
      // Marken der Treffer (nur wenn mehrere): führt auf die Ergebnisseite, gefiltert auf die Marke.
      var marken = rangfolge('marke', fd.marke, 3, function (m) { return !!m; });
      if (marken.length > 1) {
        links += '<p class="ms-drop__kopf">Marken</p><div class="ms-drop__liste">' + marken.map(function (m) {
          return opt('<span>' + esc(m) + '</span>', suchUrl(info && info.ersatz ? info.genutzt : q) + '&marke=' + encodeURIComponent(m), 'ms-kat');
        }).join('') + '</div>';
      }
      var hinweis = info && info.ersatz ? '<p class="ms-drop__hinweis">Keine Treffer für alle Wörter – Ergebnisse für „<strong>' + esc(info.genutzt) + '</strong>“</p>' : '';
      if (info && info.ersatz && info.markenHinweis) hinweis = '<p class="ms-drop__hinweis ms-drop__hinweis--marke"><strong>' + esc(info.markenHinweis) + '</strong> – ähnliche Artikel:</p>'; /* M 29.10. */
      if (info && info.bedeutung) hinweis = info.stufe === 'vielleicht' /* K */
        ? '<p class="ms-drop__hinweis"><strong>Vielleicht meinten Sie:</strong> Keine Artikel mit genau „' + esc(q) + '“</p>'
        : '<p class="ms-drop__hinweis">Keine Artikel mit genau diesen Wörtern – <strong>ähnliche Artikel</strong> zu „' + esc(q) + '“</p>'; /* K */
      if (!hits.length) {
        drop.innerHTML = '<div class="ms-drop__leer"><strong>Keine Treffer für „' + esc(q) + '“.</strong><span>Prüfen Sie die Schreibweise oder versuchen Sie einen allgemeineren Begriff (z. B. „Kleber“ statt „Spezialkleber“).</span></div>';
      } else {
        // Produkte stehen im DOM zuerst (Pfeil ↓ = erster Artikel); die Spalten ordnet das CSS.
        drop.innerHTML = hinweis + '<div class="ms-drop__grid' + (links ? '' : ' ms-drop__grid--voll') + '"><div class="ms-drop__rechts">' + rechts + '</div>' +
          (links ? '<div class="ms-drop__links">' + links + '</div>' : '') + '</div>' +
          opt(gesamt === 1 ? 'Ergebnis für „' + esc(info && info.ersatz ? info.genutzt : q) + '“ auf eigener Seite anzeigen' : 'Alle ' + gesamt.toLocaleString('de-DE') + ' Ergebnisse für „' + esc(info && info.ersatz ? info.genutzt : q) + '“ anzeigen', suchUrl(q), 'ms-alle');
      }
      aktiv = -1;
      oeffnen();
    }

    function suchen() {
      var q = input.value.trim();
      if (q.length < 2) { ergebnis = null; letzte = ''; if (document.activeElement === input) leerAnzeigen(); else schliessen(); return; }
      if (q === letzte && ergebnis) { oeffnen(); return; }
      letzte = q;
      if (laufend) laufend.abort();
      laufend = window.AbortController ? new AbortController() : null;
      var t0 = Date.now();
      Promise.all([
        sucheMitRueckfall(q, { indexUid: INDEX, limit: 6, attributesToRetrieve: DROP_FELDER, facets: ['kategorie_id', 'produktart_haupt', 'marke'] },
          [{ indexUid: KAT_INDEX, q: q, limit: 2, filter: 'ebene = 2', attributesToRetrieve: ['id'] }], laufend && laufend.signal),
        kategorien()
      ]).then(function (x) {
        if (input.value.trim() !== q) return;
        ergebnis = x[0].res;
        rendern(q, x[0].res, x[1], x[0]);
        try { var p0 = (x[0].res || [])[0] || {}; melde('dropdown', { q: q, treffer: (p0.hits || []).map(function (h) { return h.handle; }), anzahl: p0.estimatedTotalHits != null ? p0.estimatedTotalHits : (p0.totalHits || 0), dauer_ms: Date.now() - t0, filter: x[0].bedeutung ? { liste: 'bedeutung', stufe: x[0].stufe } : undefined /* K */ }); } catch (e) {}
      }).catch(function () { /* Suchdienst nicht erreichbar: normale Suche bleibt */ });
    }
    // Leeres Feld: beliebte Suchen + Bereiche (wie bei großen Baumärkten), damit niemand vor einem leeren Feld steht.
    function leerAnzeigen() {
      kategorien().then(function (kat) {
        if (input.value.trim().length >= 2 || document.activeElement !== input) return;
        var n = 0;
        function opt(html, href, cls) { n++; return '<a id="' + id + '-o' + n + '" role="option" data-ms-opt class="' + cls + '" href="' + href + '">' + html + '</a>'; }
        var bereiche = Object.keys(kat).map(function (k) { return kat[k]; }).filter(function (e) { return e.ebene === 1 && e.produkte > 0; });
        drop.innerHTML = '<div class="ms-drop__leerstart"><p class="ms-drop__kopf">Beliebte Suchen</p><div class="ms-drop__liste ms-drop__chips">' +
          BELIEBT.map(function (b) { return opt('<svg aria-hidden="true" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.6-3.6"/></svg><span>' + esc(b) + '</span>', suchUrl(b), 'ms-vorschlag'); }).join('') + '</div>' +
          (bereiche.length ? '<p class="ms-drop__kopf">Sortiment</p><div class="ms-drop__liste ms-drop__chips">' + bereiche.map(function (e) { return opt('<span>' + esc(e.name) + '</span>', '/collections/' + encodeURIComponent(e.handle), 'ms-kat'); }).join('') + '</div>' : '') + '</div>';
        aktiv = -1;
        oeffnen();
      });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(suchen, 80);
    });
    input.addEventListener('focus', function () {
      if (ergebnis && input.value.trim() === letzte && letzte) oeffnen();
      else if (input.value.trim().length < 2) leerAnzeigen();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (drop.hidden) suchen(); else markieren(aktiv + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); markieren(aktiv - 1); }
      else if (e.key === 'Escape') { schliessen(); }
      else if (e.key === 'Enter' && aktiv >= 0 && !drop.hidden) {
        e.preventDefault(); e.stopPropagation();
        window.location.assign(optionen()[aktiv].getAttribute('href'));
      }
    }, true);
    form.addEventListener('submit', function (e) {
      var q = input.value.trim();
      e.preventDefault();
      if (!q) { input.focus(); return; }
      schliessen();
      // Artikelnummer/EAN mit genau einem passenden Artikel: direkt zum Produkt.
      if (istNummer(q) && ergebnis && letzte === q) {
        var hit = ((ergebnis[0] || {}).hits || []).filter(function (h) { return (h.nummern || []).indexOf(q.replace(/\s/g, '')) >= 0; });
        if (hit.length === 1) { window.location.assign(produktUrl(hit[0], q)); return; }
      }
      if (istNummer(q)) {
        nummerImShop(q).then(function (url) { window.location.assign(url || suchUrl(q)); });
        return;
      }
      window.location.assign(suchUrl(q));
    }, true);
    document.addEventListener('mousedown', function (e) {
      if (!drop.hidden && !drop.contains(e.target) && !form.contains(e.target)) schliessen();
    });
    window.addEventListener('resize', function () { if (!drop.hidden) position(); });
    window.addEventListener('scroll', function () { if (!drop.hidden) position(); }, { passive: true });
  }

  // ---------------------------------------------------------------- Ergebnisseite
  function Ergebnisseite(root) {
    var fallback = document.getElementById('ms-fallback');
    var params = new URLSearchParams(window.location.search);
    var zustand = {
      q: (params.get('q') || '').trim(),
      kat: params.get('kat') || '',
      marke: params.getAll('marke'),
      pmin: params.get('pmin') || '',
      pmax: params.get('pmax') || '',
      lager: params.get('lager') === '1',
      sort: SORT.hasOwnProperty(params.get('sort')) ? params.get('sort') : 'relevanz',
      seite: Math.max(1, parseInt(params.get('seite') || '1', 10) || 1)
    };
    var offen = { kat: false, marke: false };
    if (!zustand.q) return;

    function filterAusdruck(ohne) {
      var f = [];
      if (zustand.kat && ohne !== 'kat') f.push('kategorie_id = ' + JSON.stringify(zustand.kat));
      if (zustand.marke.length && ohne !== 'marke') f.push('(' + zustand.marke.map(function (m) { return 'marke = ' + JSON.stringify(m); }).join(' OR ') + ')');
      if (zustand.lager && ohne !== 'lager') f.push('verfuegbar = 1');
      if (zustand.pmin !== '' && !isNaN(parseFloat(zustand.pmin)) && ohne !== 'preis') f.push('preis >= ' + parseFloat(String(zustand.pmin).replace(',', '.')));
      if (zustand.pmax !== '' && !isNaN(parseFloat(zustand.pmax)) && ohne !== 'preis') f.push('preis <= ' + parseFloat(String(zustand.pmax).replace(',', '.')));
      return f.join(' AND ');
    }
    function urlSchreiben() {
      var p = new URLSearchParams();
      p.set('type', 'product'); p.set('q', zustand.q);
      if (zustand.kat) p.set('kat', zustand.kat);
      zustand.marke.forEach(function (m) { p.append('marke', m); });
      if (zustand.pmin) p.set('pmin', zustand.pmin);
      if (zustand.pmax) p.set('pmax', zustand.pmax);
      if (zustand.lager) p.set('lager', '1');
      if (zustand.sort !== 'relevanz') p.set('sort', zustand.sort);
      if (zustand.seite > 1) p.set('seite', zustand.seite);
      history.replaceState(null, '', '/search?' + p.toString());
    }
    // Welche Anfrage wirklich gestellt wird (umgestellt bzw. Rückfall) — einmal je Suchbegriff bestimmt.
    var such = null;
    // Erster Aufbau mit ?seite=N (nach „Weitere Artikel laden“, Zurück-Knopf, Neuladen): Seiten 1…N zusammen zeigen,
    // nicht nur Seite N — sonst sieht der Kunde nach „Zurück“ plötzlich die Treffer 49 ff. (11.10.: „Tapeten“).
    var ersterAufbau = true;
    // Rückfall auf die Shopify-Liste nur bei echtem Ausfall — und dann im Protokoll als solcher markiert.
    function rueckfallMelden(grund) {
      if (fallback) fallback.hidden = false;
      try {
        var handles = [].slice.call(document.querySelectorAll('#ms-fallback .mb-card__title a')).slice(0, 12).map(function (a) {
          var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); return m ? m[1] : '';
        }).filter(Boolean);
        melde('ergebnisseite', { q: zustand.q, treffer: handles, anzahl: handles.length, seite: 1, pro_seite: PRO_SEITE, liste: 'shopify-rueckfall', grund: grund, filter: { liste: 'shopify-rueckfall', grund: grund } });
      } catch (e) {}
    }
    function laden(scrollen) {
      if (!such) {
        root.classList.add('is-laedt');
        return sucheMitRueckfall(zustand.q, { indexUid: INDEX, limit: 0 }, []).then(function (x) {
          such = x.ersatz ? { q: x.genutzt, strategie: 'all', ersatz: true, markenHinweis: x.markenHinweis || '' /* M 29.10. */ } : { q: umstellen(zustand.q), strategie: 'last', ersatz: false };
          if (x.bedeutung) such.bedeutung = true; /* K */
          return laden(scrollen);
        }).catch(function () { root.classList.remove('is-laedt'); rueckfallMelden('suchdienst-nicht-erreichbar'); });
      }
      root.classList.add('is-laedt');
      if (such.bedeutung) return bedeutungLaden(scrollen); /* K */
      var zusammen = ersterAufbau && zustand.seite > 1;
      var haupt = {
        indexUid: INDEX, q: such.q, matchingStrategy: such.strategie, hitsPerPage: zusammen ? PRO_SEITE * zustand.seite : PRO_SEITE,
        page: zusammen ? 1 : zustand.seite, attributesToRetrieve: FELDER,
        filter: filterAusdruck() || undefined, sort: SORT[zustand.sort] || undefined,
        facets: ['kategorie_id', 'marke', 'verfuegbar', 'preis']
      };
      // Facetten je Filtergruppe ohne den eigenen Filter zählen (sonst verschwinden die Alternativen).
      var queries = [haupt,
        { indexUid: INDEX, q: such.q, matchingStrategy: such.strategie, limit: 0, filter: filterAusdruck('kat') || undefined, facets: ['kategorie_id'] },
        { indexUid: INDEX, q: such.q, matchingStrategy: such.strategie, limit: 0, filter: filterAusdruck('marke') || undefined, facets: ['marke'] }];
      var t0 = Date.now();
      return Promise.all([anfrage(queries), kategorien()]).then(function (x) {
        root.classList.remove('is-laedt');
        if (fallback) fallback.hidden = true;
        root.hidden = false;
        if (zusammen && x[0][0]) x[0][0].totalPages = Math.max(1, Math.ceil((x[0][0].totalHits || 0) / PRO_SEITE));
        ersterAufbau = false;
        zeichnen(x[0], x[1]);
        try { var p1 = x[0][0] || {}; melde('ergebnisseite', { q: zustand.q, treffer: (p1.hits || []).slice(0, 12).map(function (h) { return h.handle; }), anzahl: p1.totalHits || 0, dauer_ms: Date.now() - t0, seite: zustand.seite, pro_seite: PRO_SEITE, liste: 'meili', ab_seite: zusammen ? 1 : zustand.seite, filter: { kat: zustand.kat || undefined, marke: zustand.marke.length ? zustand.marke : undefined, pmin: zustand.pmin || undefined, pmax: zustand.pmax || undefined, lager: zustand.lager ? 1 : undefined, sort: zustand.sort !== 'relevanz' ? zustand.sort : undefined, liste: 'meili', seite: zustand.seite > 1 ? zustand.seite : undefined, ab_seite: zusammen ? 1 : undefined } }); } catch (e) {}
        urlSchreiben();
        if (scrollen) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }).catch(function () {
        root.classList.remove('is-laedt');
        rueckfallMelden('suchdienst-fehler'); // normale Shopify-Ergebnisse bleiben sichtbar
      });
    }
    function facettenListe(name, verteilung, aktivWerte, beschriftung, max) {
      var keys = Object.keys(verteilung || {}).filter(Boolean).sort(function (a, b) { return verteilung[b] - verteilung[a]; });
      aktivWerte.forEach(function (w) { if (keys.indexOf(w) < 0) keys.unshift(w); });
      var mehr = keys.length > max + 1;
      if (mehr && !offen[name]) keys = keys.slice(0, max);
      return keys.map(function (k) {
        var an = aktivWerte.indexOf(k) >= 0;
        return '<label class="ms-check"><input type="' + (name === 'kat' ? 'radio' : 'checkbox') + '" name="ms-' + name + '" value="' + esc(k) + '"' + (an ? ' checked' : '') + '>' +
          '<span>' + esc(beschriftung(k)) + '</span><small>' + (verteilung[k] || 0).toLocaleString('de-DE') + '</small></label>';
      }).join('') + (mehr ? '<button type="button" class="ms-mehr" data-ms-mehr="' + name + '" aria-expanded="' + (offen[name] ? 'true' : 'false') + '">' +
        (offen[name] ? 'Weniger anzeigen' : (name === 'marke' ? 'Alle Marken anzeigen' : 'Alle Kategorien anzeigen')) + '</button>' : '');
    }
    /* K: Ergebnisseite für Bedeutungstreffer — eine Seite (max. PRO_SEITE), Filter wirken, Zähler aus den Treffern. */
    function bedeutungLaden(scrollen) {
      var t0 = Date.now();
      return Promise.all([bedeutungSuche(zustand.q, { indexUid: INDEX, limit: PRO_SEITE, attributesToRetrieve: FELDER, filter: filterAusdruck() || undefined, facets: ['kategorie_id', 'marke', 'verfuegbar'] }), kategorien()]).then(function (x) {
        root.classList.remove('is-laedt');
        if (fallback) fallback.hidden = true;
        root.hidden = false;
        ersterAufbau = false;
        var p = x[0] || { hits: [], totalHits: 0, totalPages: 1, facetDistribution: {} };
        var fd = p.facetDistribution || {};
        if (zustand.sort === 'preis_auf') p.hits.sort(function (a, b) { return a.preis - b.preis; });
        else if (zustand.sort === 'preis_ab') p.hits.sort(function (a, b) { return b.preis - a.preis; });
        else if (zustand.sort === 'name') p.hits.sort(function (a, b) { return String(a.titel).localeCompare(String(b.titel), 'de'); });
        zeichnen([p, { facetDistribution: { kategorie_id: fd.kategorie_id || {} } }, { facetDistribution: { marke: fd.marke || {} } }], x[1]);
        var h1 = root.querySelector('.ms-kopf h1');
        if (h1 && p.hits.length) {
          var vl = p.stufe === 'vielleicht';
          h1.textContent = vl ? 'Vielleicht meinten Sie:' : p.hits.length + ' ähnliche Artikel zu „' + zustand.q + '“';
          var hw = document.createElement('p'); hw.className = 'ms-kopf__hinweis';
          hw.textContent = vl ? 'Kein Artikel enthält genau „' + zustand.q + '“. Diese ' + p.hits.length + ' Artikel kommen der Bedeutung nach am nächsten – bitte prüfen Sie, ob das Gesuchte dabei ist.'
            : 'Kein Artikel enthält genau diese Wörter. Diese Artikel passen der Bedeutung nach – bitte prüfen Sie, ob das Gesuchte dabei ist.';
          h1.parentNode.appendChild(hw);
        }
        try { melde('ergebnisseite', { q: zustand.q, treffer: p.hits.slice(0, 12).map(function (h) { return h.handle; }), anzahl: p.hits.length, dauer_ms: Date.now() - t0, seite: 1, pro_seite: PRO_SEITE, liste: 'bedeutung', filter: { liste: 'bedeutung', stufe: p.stufe } }); } catch (e) {}
        urlSchreiben();
        if (scrollen) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }).catch(function () { root.classList.remove('is-laedt'); rueckfallMelden('suchdienst-fehler'); });
    }
    /* /K */
    function zeichnen(res, kat) {
      var p = res[0], hits = p.hits || [], gesamt = p.totalHits || 0, seiten = p.totalPages || 1;
      /* 0 Treffer bei Artikelnummer/EAN: Artikel außerhalb des Index (Hersteller-Zubehör) direkt öffnen */
      if (!gesamt && istNummer(zustand.q) && !zustand.nrVersucht) {
        zustand.nrVersucht = true;
        nummerImShop(zustand.q).then(function (url) { if (url) window.location.replace(url); });
      }
      var fdKat = (res[1].facetDistribution || {}).kategorie_id || {};
      var fdMarke = (res[2].facetDistribution || {}).marke || {};
      var fdLager = (p.facetDistribution || {}).verfuegbar || {};
      var stats = (p.facetStats || {}).preis || null;
      var katName = function (k) { return kat[k] ? kat[k].name : k; };
      var chips = [];
      if (zustand.kat) chips.push(['kat', zustand.kat, katName(zustand.kat)]);
      zustand.marke.forEach(function (m) { chips.push(['marke', m, m]); });
      if (zustand.pmin || zustand.pmax) chips.push(['preis', '', 'Preis ' + (zustand.pmin || '0') + '–' + (zustand.pmax || '…') + ' €']);
      if (zustand.lager) chips.push(['lager', '', 'Nur auf Lager']);
      var filterHtml =
        '<div class="ms-filter__kopf"><h2>Filter</h2><button type="button" class="ms-filter__zu" data-ms-filter-zu aria-label="Filter schließen">×</button></div>' +
        '<fieldset class="ms-gruppe"><legend>Verfügbarkeit</legend><label class="ms-check"><input type="checkbox" name="ms-lager"' + (zustand.lager ? ' checked' : '') + '><span>Nur auf Lager</span><small>' + ((fdLager['1'] || 0).toLocaleString('de-DE')) + '</small></label></fieldset>' +
        (Object.keys(fdKat).length ? '<fieldset class="ms-gruppe"><legend>Kategorie</legend>' + (zustand.kat ? '<label class="ms-check"><input type="radio" name="ms-kat" value=""><span>Alle Kategorien</span></label>' : '') + facettenListe('kat', fdKat, zustand.kat ? [zustand.kat] : [], katName, 8) + '</fieldset>' : '') +
        '<fieldset class="ms-gruppe"><legend>Preis (€)</legend><div class="ms-preis"><input type="number" class="needsclick" inputmode="decimal" min="0" step="1" name="ms-pmin" placeholder="' + (stats ? Math.floor(stats.min) : 'von') + '" value="' + esc(zustand.pmin) + '" aria-label="Preis von"><span>–</span>' +
        '<input type="number" class="needsclick" inputmode="decimal" min="0" step="1" name="ms-pmax" placeholder="' + (stats ? Math.ceil(stats.max) : 'bis') + '" value="' + esc(zustand.pmax) + '" aria-label="Preis bis"><button type="button" class="mb-btn mb-btn--ghost" data-ms-preis>OK</button></div></fieldset>' +
        (Object.keys(fdMarke).length ? '<fieldset class="ms-gruppe"><legend>Marke</legend>' + facettenListe('marke', fdMarke, zustand.marke, function (k) { return k; }, 10) + '</fieldset>' : '') +
        '<div class="ms-filter__fuss"><button type="button" class="mb-btn mb-btn--primary" data-ms-filter-zu>' + gesamt.toLocaleString('de-DE') + ' Ergebnisse anzeigen</button></div>';

      var sortHtml = '<label class="ms-sort"><span>Sortieren:</span><select data-ms-sort>' + Object.keys(SORT_NAMEN).map(function (k) {
        return '<option value="' + k + '"' + (k === zustand.sort ? ' selected' : '') + '>' + SORT_NAMEN[k] + '</option>';
      }).join('') + '</select></label>';

      var kopf = '<div class="ms-kopf"><h1>' + (gesamt ? gesamt.toLocaleString('de-DE') + ' Ergebnis' + (gesamt === 1 ? '' : 'se') + ' für „' + esc(such && such.ersatz ? such.q : zustand.q) + '“' : 'Keine Treffer für „' + esc(zustand.q) + '“') + '</h1>' +
        (such && such.ersatz && gesamt ? (such.markenHinweis ? '<p class="ms-kopf__hinweis ms-kopf__hinweis--marke"><strong>' + esc(such.markenHinweis) + '</strong> – ähnliche Artikel für „' + esc(such.q) + '“:</p>' /* M 29.10. */ : '<p class="ms-kopf__hinweis">Für „' + esc(zustand.q) + '“ gab es keinen Artikel mit allen Wörtern – wir zeigen Ergebnisse für „' + esc(such.q) + '“.</p>') : '') + '</div>';
      var leiste = '<div class="ms-leiste"><button type="button" class="mb-btn mb-btn--ghost ms-filter-knopf" data-ms-filter-auf aria-controls="ms-filter" aria-expanded="false">' +
        '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M3 5h18M6 12h12M10 19h4"/></svg>Filter' + (chips.length ? ' (' + chips.length + ')' : '') + '</button>' + sortHtml + '</div>';
      var chipsHtml = chips.length ? '<div class="ms-chips">' + chips.map(function (c) {
        return '<button type="button" class="ms-chip" data-ms-weg="' + c[0] + '" data-wert="' + esc(c[1]) + '">' + esc(c[2]) + ' <span aria-hidden="true">×</span><span class="ms-sr">Filter entfernen</span></button>';
      }).join('') + '<button type="button" class="ms-chip ms-chip--alle" data-ms-weg="alle">Alle Filter entfernen</button></div>' : '';

      var inhalt;
      if (hits.length) {
        inhalt = '<ul class="mb-grid ms-grid">' + hits.map(function (h) { return '<li>' + karteHtml(h, zustand.q) + '</li>'; }).join('') + '</ul>' + mehrHtml(zustand.seite, seiten, hits.length, gesamt, 'data-ms-mehrladen') + seitenHtml(seiten);
      } else {
        var vorschlaege = Object.keys(fdKat).slice(0, 6);
        inhalt = '<div class="ms-leer"><p><strong>Zu Ihrer Suche haben wir ' + (chips.length ? 'mit diesen Filtern ' : '') + 'nichts gefunden.</strong></p><ul>' +
          (chips.length ? '<li><button type="button" class="ms-link" data-ms-weg="alle">Filter entfernen und erneut suchen</button></li>' : '') +
          '<li>Prüfen Sie die Schreibweise oder verwenden Sie einen allgemeineren Begriff.</li><li>Suchen Sie nach der Artikelnummer oder EAN (steht auf dem Etikett).</li>' +
          '<li>Oder stöbern Sie im <a href="/collections/all">gesamten Sortiment</a> – wir beraten Sie auch gern im Markt Übach-Palenberg.</li></ul>' +
          '<p>Beliebte Suchen: ' + BELIEBT.slice(0, 8).map(function (b) { return '<a href="' + esc(suchUrl(b)) + '">' + esc(b) + '</a>'; }).join(' · ') + '</p>' +
          (vorschlaege.length ? '<p>Passende Kategorien: ' + vorschlaege.map(function (k) { return kat[k] ? '<a href="' + esc(katUrl(kat[k], zustand.q)) + '">' + esc(kat[k].name) + '</a>' : ''; }).join(' · ') + '</p>' : '') + '</div>';
      }
      if (!hits.length && !chips.length) {
        root.innerHTML = kopf + inhalt;
        return;
      }
      root.innerHTML = kopf + '<div class="ms-layout"><aside class="ms-filter" id="ms-filter" aria-label="Filter">' + filterHtml + '</aside>' +
        '<div class="ms-haupt">' + leiste + chipsHtml + inhalt + '</div></div><div class="ms-schleier" data-ms-filter-zu hidden></div>';
    }
    function seitenHtml(seiten) {
      if (seiten <= 1) return '';
      var s = zustand.seite, teile = [];
      function knopf(n, text, label) {
        return '<button type="button" class="ms-seite' + (n === s ? ' is-aktiv' : '') + '" data-ms-seite="' + n + '"' + (n === s ? ' aria-current="page"' : '') + (label ? ' aria-label="' + label + '"' : '') + '>' + text + '</button>';
      }
      if (s > 1) teile.push(knopf(s - 1, '‹', 'Vorherige Seite'));
      var von = Math.max(1, s - 2), bis = Math.min(seiten, s + 2);
      if (von > 1) { teile.push(knopf(1, '1')); if (von > 2) teile.push('<span class="ms-punkte">…</span>'); }
      for (var i = von; i <= bis; i++) teile.push(knopf(i, String(i)));
      if (bis < seiten) { if (bis < seiten - 1) teile.push('<span class="ms-punkte">…</span>'); teile.push(knopf(seiten, String(seiten))); }
      if (s < seiten) teile.push(knopf(s + 1, '›', 'Nächste Seite'));
      return '<nav class="ms-seiten" aria-label="Seiten">' + teile.join('') + '</nav>';
    }
    function filterOffen(an) {
      var f = root.querySelector('.ms-filter'), s = root.querySelector('.ms-schleier'), k = root.querySelector('[data-ms-filter-auf]');
      if (!f) return;
      f.classList.toggle('is-offen', an);
      if (s) s.hidden = !an;
      if (k) k.setAttribute('aria-expanded', an ? 'true' : 'false');
      document.documentElement.classList.toggle('ms-kein-scroll', an);
    }
    var mobilFilterOffen = false;
    function ergebnisseMehr(knopf) {
      knopf.setAttribute('aria-busy', 'true');
      var q = { indexUid: INDEX, q: such ? such.q : zustand.q, matchingStrategy: such ? such.strategie : undefined, hitsPerPage: PRO_SEITE, page: zustand.seite + 1, attributesToRetrieve: FELDER, filter: filterAusdruck() || undefined, sort: SORT[zustand.sort] || undefined };
      anfrage([q]).then(function (r) {
        var p = r[0] || {}, ul = root.querySelector('.ms-grid');
        if (!ul) return;
        (p.hits || []).forEach(function (h) { var li = document.createElement('li'); li.innerHTML = karteHtml(h, zustand.q); ul.appendChild(li); });
        zustand.seite += 1; urlSchreiben();
        var alt = root.querySelector('.mb-more'), nav = root.querySelector('.ms-seiten'), box = document.createElement('div');
        box.innerHTML = mehrHtml(zustand.seite, p.totalPages || 1, ul.children.length, p.totalHits || 0, 'data-ms-mehrladen') + seitenHtml(p.totalPages || 1);
        if (alt) alt.remove(); if (nav) nav.remove();
        while (box.firstChild) ul.parentNode.appendChild(box.firstChild);
      }).catch(function () { knopf.removeAttribute('aria-busy'); });
    }
    function neu(scrollen) { zustand.seite = 1; laden(scrollen).then(function () { if (mobilFilterOffen) filterOffen(true); }); }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'ms-lager') { zustand.lager = t.checked; neu(); }
      else if (t.name === 'ms-kat') { zustand.kat = t.value; neu(); }
      else if (t.name === 'ms-marke') {
        if (t.checked) { if (zustand.marke.indexOf(t.value) < 0) zustand.marke.push(t.value); }
        else zustand.marke = zustand.marke.filter(function (m) { return m !== t.value; });
        neu();
      } else if (t.hasAttribute('data-ms-sort')) { zustand.sort = t.value; neu(); }
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && (e.target.name === 'ms-pmin' || e.target.name === 'ms-pmax')) { e.preventDefault(); preisUebernehmen(); }
    });
    function preisUebernehmen() {
      var a = root.querySelector('[name="ms-pmin"]'), b = root.querySelector('[name="ms-pmax"]');
      zustand.pmin = a ? a.value.trim() : ''; zustand.pmax = b ? b.value.trim() : '';
      neu();
    }
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button, [data-ms-filter-zu]');
      if (!t) return;
      if (t.hasAttribute('data-ms-mehrladen')) { ergebnisseMehr(t); return; }
      if (t.hasAttribute('data-ms-seite')) { zustand.seite = parseInt(t.getAttribute('data-ms-seite'), 10); laden(true); }
      else if (t.hasAttribute('data-ms-preis')) preisUebernehmen();
      else if (t.hasAttribute('data-ms-mehr')) { var n = t.getAttribute('data-ms-mehr'); offen[n] = !offen[n]; laden().then(function () { if (mobilFilterOffen) filterOffen(true); }); }
      else if (t.hasAttribute('data-ms-filter-auf')) { mobilFilterOffen = true; filterOffen(true); }
      else if (t.hasAttribute('data-ms-filter-zu')) { mobilFilterOffen = false; filterOffen(false); }
      else if (t.hasAttribute('data-ms-weg')) {
        var art = t.getAttribute('data-ms-weg'), wert = t.getAttribute('data-wert');
        if (art === 'alle') { zustand.kat = ''; zustand.marke = []; zustand.pmin = ''; zustand.pmax = ''; zustand.lager = false; }
        else if (art === 'kat') zustand.kat = '';
        else if (art === 'marke') zustand.marke = zustand.marke.filter(function (m) { return m !== wert; });
        else if (art === 'preis') { zustand.pmin = ''; zustand.pmax = ''; }
        else if (art === 'lager') zustand.lager = false;
        neu();
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mobilFilterOffen) { mobilFilterOffen = false; filterOffen(false); } });
    laden();
  }


  // ---------------------------------------------------------------- Kategorieseite (Filter aus dem Suchdienst)
  // Ersetzt den Block .mb-coll__layout (Agent D) durch dieselbe Gestaltung, aber mit Facetten: Verfügbarkeit,
  // Unterkategorie, Produktart, Marke, Preis und je Bereich die häufigsten Merkmale (Farbe, Inhalt, Länge, Leistung …).
  // Zustand steht in der URL (teilbar, Zurück-Knopf). Fällt der Suchdienst aus, bleibt die Shopify-Liste stehen.
  var MERKMAL_NIE = { deutscher: 1, botanischer: 1, norm: 1, geeignet_fuer: 1, passend_fuer: 1, verwendung: 1 };
  function zahlWert(w) { var m = String(w).replace(/\./g, '').replace(',', '.').match(/^-?\d+(\.\d+)?/); return m ? parseFloat(m[0]) : null; }

  // „Weitere Artikel laden“ (D, 10.10.): hängt die nächste Seite an; Seitenzahl steht weiter in der URL.
  function mehrHtml(seite, seiten, gezeigt, gesamt, attr) {
    if (seite >= seiten) return '';
    return '<div class="mb-more"><p class="mb-more__info">' + gezeigt.toLocaleString('de-DE') + ' von ' + gesamt.toLocaleString('de-DE') + ' Artikeln angezeigt</p>' +
      '<button type="button" class="mb-btn mb-btn--ghost mb-more__btn" ' + attr + '>Weitere Artikel laden</button></div>';
  }

  function Kategorieseite(root) {
    var handle = root.getAttribute('data-mk-kollektion');
    var istBereich = root.getAttribute('data-mk-bereich') === '1';
    var proSeite = parseInt(root.getAttribute('data-mk-pro-seite') || '48', 10) || 48;
    var SORT_K = {
      empfohlen: ['pos.' + handle + ':asc'], beliebt: ['verfuegbar:desc', 'beliebt:desc'],
      preis_auf: ['preis:asc'], preis_ab: ['preis:desc'], name: ['titel:asc']
    };
    var SORT_K_NAMEN = { empfohlen: 'Empfohlen', beliebt: 'Beliebtheit', preis_auf: 'Preis aufsteigend', preis_ab: 'Preis absteigend', name: 'Name A–Z' };
    var offen = {}, drawer = false, z = null, kat = {}, ersterAufbau = true;

    function lesen() {
      var p = new URLSearchParams(window.location.search), m = {};
      p.forEach(function (v, k) { if (k.indexOf('m.') === 0) (m[k.slice(2)] = m[k.slice(2)] || []).push(v); });
      return {
        marke: p.getAll('marke'), art: p.getAll('art'), kat: p.getAll('kat'), m: m,
        lager: p.get('lager') === '1', pmin: p.get('pmin') || '', pmax: p.get('pmax') || '',
        sort: SORT_K.hasOwnProperty(p.get('sort')) ? p.get('sort') : 'empfohlen',
        seite: Math.max(1, parseInt(p.get('seite') || '1', 10) || 1)
      };
    }
    function schreiben(push) {
      var p = new URLSearchParams();
      z.kat.forEach(function (v) { p.append('kat', v); });
      z.art.forEach(function (v) { p.append('art', v); });
      z.marke.forEach(function (v) { p.append('marke', v); });
      Object.keys(z.m).forEach(function (k) { z.m[k].forEach(function (v) { p.append('m.' + k, v); }); });
      if (z.lager) p.set('lager', '1');
      if (z.pmin) p.set('pmin', z.pmin);
      if (z.pmax) p.set('pmax', z.pmax);
      if (z.sort !== 'empfohlen') p.set('sort', z.sort);
      if (z.seite > 1) p.set('seite', z.seite);
      var url = window.location.pathname + (p.toString() ? '?' + p.toString() : '');
      if (push) history.pushState({ mk: 1 }, '', url); else history.replaceState({ mk: 1 }, '', url);
    }
    function oder(feld, werte) {
      return werte.length ? '(' + werte.map(function (w) { return feld + ' = ' + JSON.stringify(w); }).join(' OR ') + ')' : '';
    }
    function filter(ohne) {
      var f = ['kollektionen = ' + JSON.stringify(handle)];
      if (ohne !== 'kat') f.push(oder('kollektionen', z.kat));
      if (ohne !== 'art') f.push(oder('produktart_haupt', z.art));
      if (ohne !== 'marke') f.push(oder('marke', z.marke));
      Object.keys(z.m).forEach(function (k) { if (ohne !== 'm.' + k) f.push(oder('m.' + k, z.m[k])); });
      if (z.lager && ohne !== 'lager') f.push('verfuegbar = 1');
      var a = parseFloat(String(z.pmin).replace(',', '.')), b = parseFloat(String(z.pmax).replace(',', '.'));
      if (ohne !== 'preis' && !isNaN(a)) f.push('preis >= ' + a);
      if (ohne !== 'preis' && !isNaN(b)) f.push('preis <= ' + b);
      return f.filter(Boolean).join(' AND ');
    }
    function anzahlAktiv() {
      var n = z.kat.length + z.art.length + z.marke.length + (z.lager ? 1 : 0) + ((z.pmin || z.pmax) ? 1 : 0);
      Object.keys(z.m).forEach(function (k) { n += z.m[k].length; });
      return n;
    }

    function laden(push, scrollen, perSeitenknopf) {
      root.classList.add('is-laedt');
      var basis = { indexUid: INDEX, q: '', limit: 0 };
      function mit(o) { var x = {}; for (var k in basis) x[k] = basis[k]; for (var j in o) x[j] = o[j]; return x; }
      // ?seite=N ohne Klick auf eine Seitenzahl (Zurück-Knopf, Neuladen, geteilter Link nach „Weitere laden“):
      // Seiten 1…N zusammen zeigen statt nur Seite N.
      var zusammen = z.seite > 1 && !perSeitenknopf;
      var q1 = [
        mit({ limit: undefined, hitsPerPage: zusammen ? proSeite * z.seite : proSeite, page: zusammen ? 1 : z.seite, attributesToRetrieve: FELDER, filter: filter(), sort: SORT_K[z.sort],
              facets: ['verfuegbar', 'preis', 'merkmal_namen', 'kollektionen', 'produktart_haupt', 'marke'] }),
        mit({ filter: filter('kat'), facets: ['kollektionen'] }),
        mit({ filter: filter('art'), facets: ['produktart_haupt'] }),
        mit({ filter: filter('marke'), facets: ['marke'] }),
        mit({ filter: filter('lager'), facets: ['verfuegbar'] }),
        mit({ filter: filter('preis'), facets: ['preis'] })
      ];
      return Promise.all([anfrage(q1), kategorien()]).then(function (x) {
        var r = x[0]; kat = {};
        Object.keys(x[1] || {}).forEach(function (id) { kat[x[1][id].handle] = x[1][id]; });
        var gesamt = r[0].totalHits || 0;
        // Sicherheitsnetz: Ohne Filter muss der Suchdienst die Kollektion kennen. Kennt er sie nicht oder nur zum Teil
        // (Index älter als die Kollektion), bleibt die Shopify-Liste stehen — nie eine leere Seite bei vorhandenen Produkten.
        var shopifyAnzahl = parseInt(root.getAttribute('data-mk-anzahl') || '0', 10) || 0;
        if (ersterAufbau && !anzahlAktiv() && shopifyAnzahl > 0 && gesamt < Math.ceil(shopifyAnzahl * 0.8)) {
          root.classList.remove('is-laedt');
          root.setAttribute('data-mk-rueckfall', 'index-' + gesamt + '-shop-' + shopifyAnzahl);
          throw new Error('rueckfall');
        }
        // Merkmale: die häufigsten in dieser Auswahl (≥ 15 % der Artikel, mind. 3), aktive immer.
        var nd = (r[0].facetDistribution || {}).merkmal_namen || {}, namen = {}, gruppen = [];
        Object.keys(nd).forEach(function (k) {
          var t = k.split('|'), slug = t[0];
          if (MERKMAL_NIE[slug]) return;
          if (!namen[slug] || nd[k] > namen[slug].n) namen[slug] = { name: t.slice(1).join('|'), n: nd[k] };
        });
        Object.keys(namen).sort(function (a, b) { return namen[b].n - namen[a].n; }).forEach(function (slug) {
          if (gruppen.length < 9 && (z.m[slug] || namen[slug].n >= Math.max(3, gesamt * 0.15))) gruppen.push(slug);
        });
        Object.keys(z.m).forEach(function (slug) { if (gruppen.indexOf(slug) < 0) { gruppen.push(slug); namen[slug] = namen[slug] || { name: slug, n: 0 }; } });
        var q2 = gruppen.map(function (slug) { return mit({ filter: filter('m.' + slug), facets: ['m.' + slug] }); });
        return (q2.length ? anfrage(q2) : Promise.resolve([])).then(function (r2) {
          var merk = gruppen.map(function (slug, i) {
            return { slug: slug, name: namen[slug].name, werte: ((r2[i] || {}).facetDistribution || {})['m.' + slug] || {} };
          }).filter(function (g) { return z.m[g.slug] || Object.keys(g.werte).length >= 2; });
          root.classList.remove('is-laedt');
          if (zusammen && r[0]) r[0].totalPages = Math.max(1, Math.ceil((r[0].totalHits || 0) / proSeite));
          zeichnen(r, merk, gesamt);
          schreiben(push);
          if (scrollen) { var top = root.getBoundingClientRect().top + window.pageYOffset - 170; window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' }); }
          ersterAufbau = false;
        });
      }).catch(function () { root.classList.remove('is-laedt'); /* Shopify-Liste bleibt */ });
    }

    function liste(name, verteilung, aktiv, beschriftung, typ, ordnung) {
      var keys = Object.keys(verteilung || {}).filter(Boolean);
      aktiv.forEach(function (w) { if (keys.indexOf(w) < 0) keys.push(w); });
      if (ordnung === 'zahl' || (ordnung !== 'menge' && keys.length && keys.every(function (k) { return zahlWert(k) !== null; }))) {
        keys.sort(function (a, b) { return zahlWert(a) - zahlWert(b) || a.localeCompare(b, 'de'); });
      } else {
        keys.sort(function (a, b) { return (verteilung[b] || 0) - (verteilung[a] || 0) || a.localeCompare(b, 'de'); });
      }
      var lang = keys.length > 10, zu = lang && !offen[name];
      var html = keys.map(function (k, i) {
        var an = aktiv.indexOf(k) >= 0, n = verteilung[k] || 0;
        return '<li' + (zu && i >= 8 && !an ? ' hidden' : '') + '><label class="mb-check' + (!n && !an ? ' is-disabled' : '') + '"><input type="checkbox" data-mk-feld="' + esc(name) + '" value="' + esc(k) + '"' + (an ? ' checked' : '') + (!n && !an ? ' disabled' : '') + '>' +
          '<span class="mb-check__label">' + esc(beschriftung ? beschriftung(k) : k) + '</span><span class="mb-check__n">' + n.toLocaleString('de-DE') + '</span></label></li>';
      }).join('');
      return '<ul role="list" class="mb-filter__list">' + html + '</ul>' +
        (lang ? '<button type="button" class="ms-mehr" data-mk-mehr="' + esc(name) + '" aria-expanded="' + (offen[name] ? 'true' : 'false') + '">' + (offen[name] ? 'Weniger anzeigen' : 'Alle ' + keys.length + ' anzeigen') + '</button>' : '');
    }
    function gruppe(name, titel, inhalt, auf, n) {
      if (offen.hasOwnProperty('g:' + name)) auf = offen['g:' + name];
      return '<details class="mb-filter" data-mk-gruppe="' + esc(name) + '"' + (auf ? ' open' : '') + '><summary>' + esc(titel) + (n ? ' <span class="mb-filter__count">' + n + '</span>' : '') + '</summary>' + inhalt + '</details>';
    }

    function zeichnen(r, merk, gesamt) {
      var p = r[0], hits = p.hits || [];
      var fdKat = (r[1].facetDistribution || {}).kollektionen || {};
      var fdArt = (r[2].facetDistribution || {}).produktart_haupt || {};
      var fdMarke = (r[3].facetDistribution || {}).marke || {};
      var fdLager = (r[4].facetDistribution || {}).verfuegbar || {};
      var stats = (r[5].facetStats || {}).preis || null;
      // Unterkategorien nur auf Bereichsseiten: Kollektionen, die zu diesem Bereich gehören.
      var subs = {};
      if (istBereich) Object.keys(fdKat).forEach(function (h) { if (h !== handle && h.indexOf(handle + '-') === 0 && kat[h]) subs[h] = fdKat[h]; });
      var offenSet = function (name, aktivN, idx) { return aktivN > 0 || (idx < 4 && !window.matchMedia('(max-width: 991px)').matches) || idx < 2; };
      var html = '', idx = 0;
      html += '<div class="mb-filter mb-filter--single"><label class="mb-check mb-check--switch"><input type="checkbox" data-mk-lager' + (z.lager ? ' checked' : '') + '>' +
        '<span class="mb-check__label"><strong>Nur vorrätige Artikel</strong><small>sofort lieferbar oder abholbereit</small></span><span class="mb-check__n">' + (fdLager['1'] || 0).toLocaleString('de-DE') + '</span></label></div>';
      if (Object.keys(subs).length > 1 || z.kat.length) html += gruppe('kat', 'Kategorie', liste('kat', subs, z.kat, function (h) { return kat[h] ? kat[h].name : h; }, 'kat', 'menge'), offenSet('kat', z.kat.length, idx++), z.kat.length);
      // Produktart-Werte mit Ziffern sind Merkmale, die im Katalog als Art stehen („GY6.35“, „Hochvolt (240V)“).
      Object.keys(fdArt).forEach(function (a) { if (/\d/.test(a) && z.art.indexOf(a) < 0) delete fdArt[a]; });
      if (Object.keys(fdArt).length > 1 || z.art.length) html += gruppe('art', 'Produktart', liste('art', fdArt, z.art, null, 'art', 'menge'), offenSet('art', z.art.length, idx++), z.art.length);
      if (Object.keys(fdMarke).length > 1 || z.marke.length) html += gruppe('marke', 'Marke', liste('marke', fdMarke, z.marke, null, 'marke', 'menge'), offenSet('marke', z.marke.length, idx++), z.marke.length);
      html += gruppe('preis', 'Preis', '<p class="mb-price__hint">' + (stats ? 'Preise in dieser Auswahl: ' + euro(stats.min) + ' – ' + euro(stats.max) : '') + '</p><div class="mb-price">' +
        '<label><span>von</span><input type="number" class="needsclick" inputmode="decimal" min="0" data-mk-pmin value="' + esc(z.pmin) + '" placeholder="' + (stats ? Math.floor(stats.min) : '0') + '"></label>' +
        '<label><span>bis</span><input type="number" class="needsclick" inputmode="decimal" min="0" data-mk-pmax value="' + esc(z.pmax) + '" placeholder="' + (stats ? Math.ceil(stats.max) : '') + '"></label>' +
        '<button type="button" class="mb-btn mb-btn--ghost" data-mk-preis>OK</button></div>', (z.pmin || z.pmax) || idx < 4, (z.pmin || z.pmax) ? 1 : 0);
      idx++;
      merk.forEach(function (g) {
        var akt = z.m[g.slug] || [];
        html += gruppe('m.' + g.slug, g.name, liste('m.' + g.slug, g.werte, akt, null, 'm', null), offenSet(g.slug, akt.length, idx++), akt.length);
      });
      var n = anzahlAktiv();
      var aside = '<aside class="mb-filters' + (drawer ? ' is-open' : '') + '" id="mb-filters" aria-label="Filter"><div class="mb-filters__top"><h2 class="mb-filters__h">Filter</h2>' +
        '<button type="button" class="mb-filters__close" data-mk-zu aria-label="Filter schließen"><svg aria-hidden="true" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>' + html +
        '<div class="mb-filters__submit"><button type="button" class="mb-btn mb-btn--primary" data-mk-zu>' + gesamt.toLocaleString('de-DE') + ' Artikel anzeigen</button>' +
        (n ? '<button type="button" class="mb-btn mb-btn--ghost" data-mk-weg="alle">Zurücksetzen</button>' : '') + '</div></aside>';

      // aktive Filter als Chips
      var chips = [];
      z.kat.forEach(function (v) { chips.push(['kat', v, kat[v] ? kat[v].name : v]); });
      z.art.forEach(function (v) { chips.push(['art', v, v]); });
      z.marke.forEach(function (v) { chips.push(['marke', v, v]); });
      merk.forEach(function (g) { (z.m[g.slug] || []).forEach(function (v) { chips.push(['m.' + g.slug, v, g.name + ': ' + v]); }); });
      if (z.lager) chips.push(['lager', '', 'Nur vorrätige']);
      if (z.pmin || z.pmax) chips.push(['preis', '', (z.pmin ? 'ab ' + z.pmin + ' €' : '') + (z.pmin && z.pmax ? ' ' : '') + (z.pmax ? 'bis ' + z.pmax + ' €' : '')]);
      var chipsHtml = chips.length ? '<div class="mb-active">' + chips.map(function (c) {
        return '<button type="button" class="mb-chip mb-chip--active" data-mk-weg="' + esc(c[0]) + '" data-wert="' + esc(c[1]) + '">' + esc(c[2]) + ' <span aria-hidden="true">×</span><span class="ms-sr">Filter entfernen</span></button>';
      }).join('') + '<button type="button" class="mb-active__reset ms-link" data-mk-weg="alle">Alle Filter entfernen</button></div>' : '';

      var toolbar = '<div class="mb-toolbar"><p class="mb-toolbar__count"><strong>' + gesamt.toLocaleString('de-DE') + '</strong> Artikel</p>' +
        '<button type="button" class="mb-btn mb-btn--ghost mb-toolbar__filter" data-mk-auf aria-controls="mb-filters" aria-expanded="' + (drawer ? 'true' : 'false') + '"><svg aria-hidden="true" viewBox="0 0 24 24"><path d="M3 5h18M6 12h12M10 19h4"/></svg>Filter' + (n ? ' (' + n + ')' : '') + '</button>' +
        '<label class="mb-sort"><span>Sortieren:</span><select data-mk-sort aria-label="Sortieren">' + Object.keys(SORT_K_NAMEN).map(function (k) {
          return '<option value="' + k + '"' + (k === z.sort ? ' selected' : '') + '>' + SORT_K_NAMEN[k] + '</option>';
        }).join('') + '</select></label></div>';
      var inhalt = hits.length
        ? '<ul class="mb-grid" role="list">' + hits.map(function (h) { return '<li>' + karteHtml(h, '') + '</li>'; }).join('') + '</ul>' + mehrHtml(z.seite, p.totalPages || 1, hits.length, gesamt, 'data-mk-mehrladen') + seiten(p.totalPages || 1)
        : '<div class="mb-empty"><h2>Keine Artikel gefunden</h2><p>Mit diesen Filtern gibt es keine Treffer. <button type="button" class="ms-link" data-mk-weg="alle">Filter zurücksetzen</button></p></div>';
      root.innerHTML = aside + '<div class="mb-coll__main">' + toolbar + chipsHtml + inhalt + '</div>';
      document.documentElement.classList.toggle('mb-drawer-open', drawer);
    }
    function seiten(n) {
      if (n <= 1) return '';
      var s = z.seite, t = [];
      function k(i, text, cls, label) { return '<button type="button" class="' + cls + (i === s && cls === 'mb-pages__n' ? ' is-current' : '') + '" data-mk-seite="' + i + '"' + (i === s ? ' aria-current="page"' : '') + (label ? ' aria-label="' + label + '"' : '') + '>' + text + '</button>'; }
      if (s > 1) t.push(k(s - 1, '‹ Zurück', 'mb-pages__btn', 'Vorherige Seite'));
      var von = Math.max(1, s - 2), bis = Math.min(n, s + 2);
      if (von > 1) { t.push(k(1, '1', 'mb-pages__n')); if (von > 2) t.push('<span class="mb-pages__gap">…</span>'); }
      for (var i = von; i <= bis; i++) t.push(k(i, String(i), 'mb-pages__n'));
      if (bis < n) { if (bis < n - 1) t.push('<span class="mb-pages__gap">…</span>'); t.push(k(n, String(n), 'mb-pages__n')); }
      if (s < n) t.push(k(s + 1, 'Weiter ›', 'mb-pages__btn', 'Nächste Seite'));
      return '<nav class="mb-pages" aria-label="Seiten">' + t.join('') + '</nav>';
    }
    function setDrawer(an) {
      drawer = an;
      var a = root.querySelector('.mb-filters'), b = root.querySelector('[data-mk-auf]');
      if (a) a.classList.toggle('is-open', an);
      if (b) b.setAttribute('aria-expanded', an ? 'true' : 'false');
      document.documentElement.classList.toggle('mb-drawer-open', an);
    }
    function neu() { z.seite = 1; laden(true); }
    function mehrLaden(knopf) {
      knopf.setAttribute('aria-busy', 'true');
      var q = { indexUid: INDEX, q: '', hitsPerPage: proSeite, page: z.seite + 1, attributesToRetrieve: FELDER, filter: filter(), sort: SORT_K[z.sort] };
      anfrage([q]).then(function (r) {
        var p = r[0] || {}, ul = root.querySelector('.mb-grid');
        if (!ul) return;
        (p.hits || []).forEach(function (h) { var li = document.createElement('li'); li.innerHTML = karteHtml(h, ''); ul.appendChild(li); });
        z.seite += 1; schreiben(true);
        var alt = root.querySelector('.mb-more'), nav = root.querySelector('.mb-pages'), box = document.createElement('div');
        box.innerHTML = mehrHtml(z.seite, p.totalPages || 1, ul.children.length, p.totalHits || 0, 'data-mk-mehrladen') + seiten(p.totalPages || 1);
        if (alt) alt.remove(); if (nav) nav.remove();
        while (box.firstChild) ul.parentNode.appendChild(box.firstChild);
      }).catch(function () { knopf.removeAttribute('aria-busy'); });
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-mk-lager')) { z.lager = t.checked; neu(); return; }
      if (t.hasAttribute('data-mk-sort')) { z.sort = t.value; neu(); return; }
      var feld = t.getAttribute('data-mk-feld');
      if (!feld) return;
      var liste = feld.indexOf('m.') === 0 ? (z.m[feld.slice(2)] = z.m[feld.slice(2)] || []) : z[feld];
      var i = liste.indexOf(t.value);
      if (t.checked && i < 0) liste.push(t.value);
      if (!t.checked && i >= 0) liste.splice(i, 1);
      if (feld.indexOf('m.') === 0 && !liste.length) delete z.m[feld.slice(2)];
      neu();
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && (e.target.hasAttribute('data-mk-pmin') || e.target.hasAttribute('data-mk-pmax'))) { e.preventDefault(); preis(); }
    });
    function preis() {
      var a = root.querySelector('[data-mk-pmin]'), b = root.querySelector('[data-mk-pmax]');
      z.pmin = a ? a.value.trim() : ''; z.pmax = b ? b.value.trim() : ''; neu();
    }
    root.addEventListener('toggle', function (e) {
      var d = e.target; if (d.tagName === 'DETAILS') offen['g:' + d.getAttribute('data-mk-gruppe')] = d.open;
    }, true);
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-mk-seite],[data-mk-preis],[data-mk-mehr],[data-mk-auf],[data-mk-zu],[data-mk-weg],[data-mk-mehrladen]');
      if (!t) return;
      if (t.hasAttribute('data-mk-mehrladen')) { mehrLaden(t); return; }
      if (t.hasAttribute('data-mk-seite')) { z.seite = parseInt(t.getAttribute('data-mk-seite'), 10); laden(true, true, true); }
      else if (t.hasAttribute('data-mk-preis')) preis();
      else if (t.hasAttribute('data-mk-mehr')) {
        var n = t.getAttribute('data-mk-mehr'); offen[n] = !offen[n];
        var ul = t.previousElementSibling;
        if (ul) [].forEach.call(ul.children, function (li, i) { if (i >= 8 && !li.querySelector('input:checked')) li.hidden = !offen[n]; });
        t.setAttribute('aria-expanded', offen[n] ? 'true' : 'false');
        t.textContent = offen[n] ? 'Weniger anzeigen' : 'Alle ' + (ul ? ul.children.length : '') + ' anzeigen';
      }
      else if (t.hasAttribute('data-mk-auf')) setDrawer(true);
      else if (t.hasAttribute('data-mk-zu')) setDrawer(false);
      else if (t.hasAttribute('data-mk-weg')) {
        var art = t.getAttribute('data-mk-weg'), w = t.getAttribute('data-wert');
        if (art === 'alle') { z.kat = []; z.art = []; z.marke = []; z.m = {}; z.lager = false; z.pmin = ''; z.pmax = ''; }
        else if (art === 'lager') z.lager = false;
        else if (art === 'preis') { z.pmin = ''; z.pmax = ''; }
        else if (art.indexOf('m.') === 0) { var s = art.slice(2); z.m[s] = (z.m[s] || []).filter(function (v) { return v !== w; }); if (!z.m[s].length) delete z.m[s]; }
        else z[art] = z[art].filter(function (v) { return v !== w; });
        neu();
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer) setDrawer(false); });
    window.addEventListener('popstate', function () { z = lesen(); laden(false); });
    z = lesen();
    laden(false);
  }

  function start() {
    var forms = document.querySelectorAll('form[action="/search"], form[action$="/search"]');
    for (var i = 0; i < forms.length; i++) Sofortsuche(forms[i]);
    var seite = document.getElementById('ms-seite');
    if (seite) Ergebnisseite(seite);
    var koll = document.querySelector('[data-mk-kollektion]');
    if (koll) Kategorieseite(koll);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
